<template>
    <div class="page-wrapper">
        <div class="left-panel-section">
            <div class="left-panel-section-tabs">
                <widgetTabs class="fill" :value="leftTabOptions.findIndex(obj => obj.value === left_active_tab) + 1"
                    :tabs="leftTabOptions" @change="(tab) => {
                        left_active_tab = tab.value;
                    }">
                </widgetTabs>
            </div>
            <div class="left-panel-section-body" :class="{ disableScoll: left_active_tab == 'profile' }">
                <div v-if="left_active_tab == 'templates'" class="panel-tab-container">
                    <EditorTemplatesList @createNewTemplate="createNewTemplate()" :account_type="account_type"
                        @loadAsTemplate="loadAsTemplate" @duplicateTemplate="duplicateTemplate">
                    </EditorTemplatesList>
                </div>
                <div v-if="left_active_tab == 'components'" class="panel-tab-container">
                    <EditorTemplateTools :isPageHover="isPageContainerHover" @onToolSelected="onToolSelected">
                    </EditorTemplateTools>
                </div>
                <div v-if="left_active_tab == 'layers'" class="panel-layer-container">
                    <EditorLayerViewer v-for="(item, index) in layers" :key="index" :layer="item"
                        :name="item.itemId + index" @selectElement="() => {
                            item.itemSelected = true;
                        }"></EditorLayerViewer>
                </div>
                <div v-if="left_active_tab == 'profile'" class="panel-tab-container">
                    <ProfileInformation :template="selectedTemplate" :profileData="selectedProfile"
                        @editAppliedCv="editAppliedCv($event, isEditingCv)"></ProfileInformation>
                </div>
                <div v-if="left_active_tab == 'draft'" class="panel-tab-container">
                    <EditorDraftCvList :templateAllowedVersion="templateAllowedVersion" @editDraftedCv="initiateEditCv">
                    </EditorDraftCvList>
                </div>
            </div>
        </div>
        <div class="middle-panel-section">
            <div class="middle-panel-section-header">
                <div class="cv-left-options">
                    <div class="history-navigational-options">
                        <button class="btn-backward" @click="unDoEditingHistory()"
                            :class="{ inactive: activeHistoryIndex <= 0 }">
                            <img src="@/views/Resume/icons/arrow-go-back-line-active.svg">
                        </button>
                        <button class="btn-forward" :class="{ inactive: activeHistoryIndex >= historyStack.length - 1 }"
                            @click="reDoEditingHistory()">
                            <img src="@/views/Resume/icons/arrow-go-forward-line-active.svg">
                        </button>
                    </div>
                    <div class="option-divider"></div>
                    <div class="zoom-options">
                        <button class="btn-zoom-out" @click="pageZoomOut()">
                            <img src="@/views/Resume/icons/zoom-out-active.svg">
                        </button>
                        <vueSlider tooltipPlacement="bottom" style="width: 200px; background: #ddd" :interval="1"
                            :tooltip-formatter="'{value}%'" :min="30" :max="350" height="10px" v-model="parcent_zoom"
                            @change="onChangeZoom" />
                        <button class="btn-zoom-in" @click="pageZoomIn()">
                            <img src="@/views/Resume/icons/zoom-in-active.svg">
                        </button>
                    </div>
                    <div class="option-divider"></div>
                    <div class="template-versions-options">
                        <widgetDropdown v-model="show_template_versions_filter" :right="true" :hover="false"
                            :interactive="true">
                            <button class="btn-dropdown btn-template-versions">
                                Resume Size
                                <img class="icon" src="./icons/arrow-down.svg" />
                            </button>
                            <div slot="dropdown" class="dropdown-widget right">
                                <a class="dropdown-item" href="#" v-for="(item, index) in template_versitions" :key="index"
                                    @click="onChangeTemplateVersion(item.value)">
                                    {{ item.name }} - {{ item.message }}</a>
                            </div>
                        </widgetDropdown>
                    </div>
                    <div class="option-divider"></div>
                    <div class="template-versions-options">
                        <widgetButton :loading="false" @click="importTemplate()" class="btn-transparent-secondary"
                            style="color: #038888;">
                            Import
                        </widgetButton>
                        <input type="file" style="display:none" id="template-file-import-input" @change="onFileImported"
                            accept="application/json">
                    </div>

                </div>
                <div class="cv-right-options row" v-if="!isApplyingProfile">
                    <widgetButton :loading="false" @click="showSaveTemplateModal()" class="btn-secondary-outline">
                        Save Template
                    </widgetButton>
                    <div class="h-spacer"></div>
                    <widgetButton :loading="false" @click="applyTemplate()" class="btn-secondary">
                        Use template
                    </widgetButton>
                    <div class="h-spacer"></div>
                    <widgetButton :loading="false" @click="backToCvs()" class="btn-transparent-secondary"
                        style="color: #038888;">
                        Back
                    </widgetButton>
                </div>
                <div v-else class="cv-right-options row">
                    <widgetButton :loading="loadingDownloadingCv" @click="downloadCv()" class="btn-secondary">
                        Download
                    </widgetButton>
                    <div class="h-spacer">
                    </div>
                    <widgetButton :loading="loadingDownloadingCv" @click="showSaveCvModal()" class="btn-secondary-outline">
                        Save
                    </widgetButton>
                    <div class="h-spacer">
                    </div>
                    <app-dialog title="Save CV as Draft?" class="approve-widget"
                        ask="Would you like to save the changes you've made as a draft for later use before exiting the CV editing page? This will allow you to come back and continue editing at a later time."
                        yesText="Save as draft" noText="Cancel" yesBtnClass="approve-widget"
                        @onComfirm="showSaveCvAsDraftModal()" @onCancel="createNewTemplate()">
                        <widgetButton :loading="false" class="btn-transparent-secondary" style="color: #AA3030;">
                            Exit
                        </widgetButton>
                    </app-dialog>
                </div>
            </div>
            <div class="middle-panel-section-body">
                <div class="middle-panel-section-body-page">
                    <div class="transformation-widget">
                        <div class="transformation-top-left-corner-widget" data-type="transformer"></div>
                        <div class="transformation-top-right-corner-widget" data-type="transformer"></div>
                        <div class="transformation-bottom-left-corner-widget" data-type="transformer"></div>
                        <div class="transformation-bottom-right-corner-widget" data-type="transformer"></div>
                        <div class="transformation-top-widget" data-type="transformer"></div>
                        <div class="transformation-bottom-widget" data-type="transformer"></div>
                        <div class="transformation-rotation-widget">
                            <button class="transformation-rotate">
                                <img src="@/assets/cv-editor-icons/rotate.svg" />
                            </button>
                        </div>
                        <div class="transformation-left-widget" data-type="transformer"></div>
                        <div class="transformation-right-widget" data-type="transformer"></div>
                        <div class="transformation-center-widget" data-type="transformer"></div>
                    </div>
                    <div v-if="!show_apply_profile_modal" @click.self="onClickOutsideOfPage()"
                        class="cv-template-pages-wrapper">

                        <div class="cv-template-pages-wrapper-inner">
                            <div class="cv-template-pages-wrapper-inner-container">

                                <div class="cv-template-page-wrapper" v-for="(page, pageIndex) in layers" :key="pageIndex"
                                    :style="{ 'z-index': 999 - pageIndex }">

                                    <div class="page-options" :id="page.itemId + '_page_options'">
                                        <div class="page-left-option">
                                            Page {{ pageIndex + 1 }}
                                        </div>
                                        <div class="page-right-option">
                                            <div @click="duplicatePage(page)" class="page-option">
                                                <img src="./icons/duplicate_page.svg">
                                            </div>
                                            <div v-if="layers.length > 1" @click="deletePage(page, pageIndex)"
                                                class="page-option">
                                                <img src="./icons/delete_page.svg">
                                            </div>
                                            <div @click="newPage(page)" class="page-option">
                                                <img src="./icons/new_page.svg">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="cv-page-container">
                                        <div class="cv-template-page" @mouseover="onPageContainerMouseover"
                                            @mouseup="onPageContainerMouseup" @mouseleave="onPageContainerMouseleave"
                                            @click.self="onPageSelected(page)" :id="page.itemId" :layer-level="0"
                                            :layer-index="pageIndex" :layer-type="page.itemType" layer-parent-type="none"
                                            :layer-parent-index="null" :layer-index-path="JSON.stringify([pageIndex])">

                                            <template v-for="(item, index) in page.children">
                                                <template
                                                    v-if="item.itemType == 'container_element' && item.dataOrigin != '' && !isApplyingProfile">
                                                    <EditorTemplateElementViewer v-for="(n, j) in item.numberOfItems"
                                                        :key="'guost_' + j + n" :layer="item" @selectElement="() => {
                                                            item.itemSelected = true;
                                                        }" :itemLayerIndex="index" :itemLayerLever="1"
                                                        :isGuostItem="j > 0" :GuostItemIndex="j"
                                                        :itemParentLayerType="page.itemType"
                                                        :itemLayerIndexPath="[pageIndex]" :readonly="isPageReadOnly"
                                                        @deleteElement="onDeleteElement(page, index)">
                                                    </EditorTemplateElementViewer>
                                                </template>
                                                <EditorTemplateElementViewer v-else :key="index"
                                                    :layer="{ ...item, parent: page }" @selectElement="() => {
                                                        item.itemSelected = true;
                                                    }" :itemLayerIndex="index" :itemLayerLever="1"
                                                    :itemParentLayerType="page.itemType" :itemLayerIndexPath="[pageIndex]"
                                                    @deleteElement="onDeleteElement(page, index)" :readonly="isPageReadOnly"
                                                    :isApplyingProfile="isApplyingProfile">
                                                </EditorTemplateElementViewer>
                                            </template>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>

                    </div>
                </div>
                <div class="right-panel-section" v-if="selectedElement">
                    <div class="right-panel-section-top-header">
                        <span>{{ selectedElement.itemName }}</span>
                    </div>
                    <div class="right-panel-section-header">
                        <widgetTabs class="fill"
                            :value="rightTabOptions.findIndex(obj => obj.value === right_active_tab) + 1"
                            :tabs="rightTabOptions" @change="(tab) => { right_active_tab = tab.value }">
                        </widgetTabs>
                    </div>
                    <div class="right-panel-section-body">
                        <EditorTemplateStylesProperties v-if="right_active_tab == 'layout' || right_active_tab == 'format'"
                            :selectedElement="selectedElement" :activeTab="right_active_tab"
                            @onPositionTypeChange="onPositionTypeChange"
                            @onPositionTopValueChange="onPositionTopValueChange"
                            @onPositionBottomValueChange="onPositionBottomValueChange"
                            @onPositionRightValueChange="onPositionRightValueChange"
                            @onPositionLeftValueChange="onPositionLeftValueChange"
                            @onElementWidthValueChange="onElementWidthValueChange"
                            @onElementHeightValueChange="onElementHeightValueChange"
                            @onWidthSizeTypeValueChange="onWidthSizeTypeValueChange"
                            @onHeightSizeTypeValueChange="onHeightSizeTypeValueChange"
                            @onElementLayoutTypeValueChange="onElementLayoutTypeValueChange"
                            @onElementLayoutDirectionValueChange="onElementLayoutDirectionValueChange"
                            @onElementLayoutDistributeValueChange="onElementLayoutDistributeValueChange"
                            @onElementLayoutAlignValueChange="onElementLayoutAlignValueChange"
                            @onElementLayoutGapValueChange="onElementLayoutGapValueChange"
                            @onElementLayoutPaddingTopValueChange="onElementLayoutPaddingTopValueChange"
                            @onElementLayoutPaddingBottomValueChange="onElementLayoutPaddingBottomValueChange"
                            @onElementLayoutPaddingLeftValueChange="onElementLayoutPaddingLeftValueChange"
                            @onElementLayoutPaddingRightValueChange="onElementLayoutPaddingRightValueChange"
                            @onElementLayoutMarginTopValueChange="onElementLayoutMarginTopValueChange"
                            @onElementLayoutMarginBottomValueChange="onElementLayoutMarginBottomValueChange"
                            @onElementLayoutMarginLeftValueChange="onElementLayoutMarginLeftValueChange"
                            @onElementLayoutMarginRightValueChange="onElementLayoutMarginRightValueChange"
                            @onElementBorderTypeValueChange="onElementBorderTypeValueChange"
                            @onElementBorderTopSizeValueChange="onElementBorderTopSizeValueChange"
                            @onElementBorderTopColorValueChange="onElementBorderTopColorValueChange"
                            @onElementBorderBottomSizeValueChange="onElementBorderBottomSizeValueChange"
                            @onElementBorderBottomColorValueChange="onElementBorderBottomColorValueChange"
                            @onElementBorderLeftSizeValueChange="onElementBorderLeftSizeValueChange"
                            @onElementBorderLeftColorValueChange="onElementBorderLeftColorValueChange"
                            @onElementBorderRightSizeValueChange="onElementBorderRightSizeValueChange"
                            @onElementBorderRightColorValueChange="onElementBorderRightColorValueChange"
                            @onElementBorderTopLeftRadiusValueChange="onElementBorderTopLeftRadiusValueChange"
                            @onElementBorderTopRightRadiusValueChange="onElementBorderTopRightRadiusValueChange"
                            @onElementBorderBottomLeftRadiusValueChange="onElementBorderBottomLeftRadiusValueChange"
                            @onElementBorderBottomRightRadiusValueChange="onElementBorderBottomRightRadiusValueChange"
                            @onElementBackgoundColorValueChange="onElementBackgoundColorValueChange"
                            @onElementTextColorValueChange="onElementTextColorValueChange"
                            @onTextFontFamilyChange="onTextFontFamilyChange"
                            @onTextFontWeightChange="onTextFontWeightChange" @onTextFontStyleChange="onTextFontStyleChange"
                            @onTextDecorationChange="onTextDecorationChange" @onTextCaseChange="onTextCaseChange"
                            @onElementTextSizeValueChange="onElementTextSizeValueChange"
                            @onTextLineSpacingChange="onTextLineSpacingChange" @onTextContentChange="onTextContentChange"
                            @onTextAlignValueChange="onTextAlignValueChange"
                            @onProfileContentValueChange="onProfileContentValueChange"
                            @onElementWrapContentValueChange="onElementWrapContentValueChange"
                            @onImageSelected="onImageSelected">
                        </EditorTemplateStylesProperties>
                        <EditorTemplateDataProperties v-if="right_active_tab == 'attribute'"
                            :selectedElement="selectedElement" @onDataOriginChange="onDataOriginChange"
                            @onNumberItemsChange="onNumberItemsChange">
                        </EditorTemplateDataProperties>
                    </div>
                </div>
                <div class="right-panel-section" v-else></div>

            </div>
            <div class="middle-panel-section-footer">

            </div>
        </div>


        <!-- Apply profile modal-->
        <ApplyProfileCvModal v-if="show_apply_profile_modal" @close="show_apply_profile_modal = false" :pages="layers"
            @editAppliedCv="editAppliedCv($event, false)">
        </ApplyProfileCvModal>

        <!-- Save template modal -->
        <widgetModal v-if="show_template_form"
            :title="formTemp.id ? 'Update Template Information' : applyBeforeSaveTempWarn ? 'Add template before apply' : 'Add Template Information'"
            subtitle="Fill in the information below " :btnlefttext="applyBeforeSaveTempWarn ? 'Continue' : 'Save Changes'"
            btncentertext="Cancel" btnrighttext="" :hiderightbtn="true" :leftloading="save_template_loading"
            :rightloading="false" :centerloading="false" :footerhidden="false" footer_padding="10px 18px 30px 30px"
            header_padding="30px 0px 0px 31px" body_padding="0px 30px" width="550px" @onLeftClick="saveTemplate()"
            @onCenterClick="show_template_form = false">
            <div class="widget-modal-body-noscoll">
                <div class="row">
                    <widgetInputWrapper title="Template name">
                        <widgetInput type="text" v-model="formTemp.name" placeholder=""></widgetInput>
                    </widgetInputWrapper>
                </div>
                <div class="row">
                    <widgetInputWrapper title="Template description">
                        <widgetTextarea v-model="formTemp.description" placeholder=""></widgetTextarea>
                    </widgetInputWrapper>
                </div>
            </div>
        </widgetModal>

        <!-- Add new cv modal -->
        <widgetModal v-if="show_add_new_cv_form" :title="formCV.id ? 'Update Cv information' : 'Create CV'"
            subtitle="Fill in the information below " btnlefttext="Save Changes" btncentertext="Cancel" btnrighttext=""
            :hiderightbtn="true" :leftloading="save_cv_loading" :rightloading="false" :centerloading="false"
            :footerhidden="false" footer_padding="30px 18px 30px 30px" header_padding="30px 0px 0px 31px"
            body_padding="0px 30px" width="550px" @onLeftClick="saveCv()" @onCenterClick="show_add_new_cv_form = false">
            <div class="widget-modal-body-noscoll">
                <div class="row">
                    <widgetInputWrapper title="CV Name">
                        <widgetInput type="text" v-model="formCV.name" placeholder=""></widgetInput>
                    </widgetInputWrapper>
                </div>
                <div class="row">
                    <widgetInputWrapper title="CV Description">
                        <widgetTextarea v-model="formCV.description" placeholder=""></widgetTextarea>
                    </widgetInputWrapper>
                </div>
            </div>
        </widgetModal>

        <!-- Add new template component modal -->
        <widgetModal v-if="showSaveComponentModal" title="Create New Component" subtitle="Fill in the information below "
            btnlefttext="Save Changes" btncentertext="Cancel" btnrighttext="" :hiderightbtn="true"
            :leftloading="loadingSaveComponent" :rightloading="false" :centerloading="false" :footerhidden="false"
            footer_padding="30px 18px 30px 30px" header_padding="30px 0px 0px 31px" body_padding="0px 30px" width="550px"
            @onLeftClick="saveTemplateComponent()" @onCenterClick="showSaveComponentModal = false">
            <div class="widget-modal-body-noscoll">
                <div class="row">
                    <widgetInputWrapper title="Component Name">
                        <widgetInput type="text" v-model="formTemplateComponent.title" placeholder=""></widgetInput>
                    </widgetInputWrapper>
                </div>
            </div>
        </widgetModal>

    </div>
</template>
<script>
import { eventBus } from "@/main";
import { SITE_API, ACCOUNT_TYPE, FILE_MAKER_SERVER_BASE_URL } from "@/Store/variable.js";
import EditorLayerViewer from "./components/editor_layer_viewer.vue";
import EditorTemplateElementViewer from "./components/editor_template_element_viewer.vue";
import EditorTemplatesList from "./components/editor_templates_list.vue";
import EditorTemplateTools from "./components/editor_template_tools.vue";
import EditorTemplateStylesProperties from "./components/editor_template_styles_properties.vue";
import EditorTemplateDataProperties from "./components/editor_template_data_properties.vue";
import ApplyProfileCvModal from "./profiles_cvs/apply_profile_cv_modal.vue"
import ProfileInformation from "./profiles_cvs/profile_information.vue"
import EditorDraftCvList from "./components/editor_cvs_draft_list.vue";
import domtoimage from "@/libs/dom-to-image.js";
import VueSlider from "vue-slider-component";
import "@/styles/slider.scss";
import "@/libs/domvas.js";
export default {
    components: {
        EditorTemplatesList,
        EditorLayerViewer,
        EditorTemplateElementViewer,
        EditorTemplateTools,
        EditorTemplateStylesProperties,
        EditorTemplateDataProperties,
        ApplyProfileCvModal,
        VueSlider,
        ProfileInformation,
        EditorDraftCvList
    },
    props: {
        payload: {
            type: Object,
            default: null
        },
        templateAllowedVersion: {
            type: String,
            default: "1.3"
        }
    },
    data: function () {
        return {
            account_type: ACCOUNT_TYPE,
            show_apply_profile_modal: false,
            isPageContainerHover: false,
            left_active_tab: 'templates',
            right_active_tab: 'layout',
            cv_versions_active_tab: 1,
            layers: [],
            template_versions: {
                default: null,
                medium: null,
                extended: null
            },
            active_template_version: 'default',
            selectedElement: null,
            show_template_form: false,
            save_template_loading: false,
            formTemp: { id: null, name: "", description: "", cvData: null, thumb: null },
            show_add_new_cv_form: false,
            save_cv_loading: false,
            formCV: {
                id: null,
                templateId: null,
                name: "",
                user_id: "",
                description: "",
                file: null,
                isDraft: false,
                origin: "internal",
                cvData: "",
            },
            isEditingCv: false,
            pageZoomLevel: 1,
            historyStack: [],
            activeHistoryIndex: -1,
            parcent_zoom: 100,
            isApplyingProfile: false,
            isPageReadOnly: false,
            loadingDownloadingCv: false,
            selectedTemplate: null,
            selectedProfile: null,
            applyBeforeSaveTempWarn: false,
            show_template_versions_filter: false,
            template_versitions: [
                {
                    name: "Default",
                    message: "1 to 2 pages",
                    value: "default"
                },
                {
                    name: "Medium",
                    message: "2 to 4 pages",
                    value: "medium"
                },
                {
                    name: "Extended",
                    message: "4 and more pages",
                    value: "extended"
                }
            ],
            showSaveComponentModal: false,
            loadingSaveComponent: false,
            formTemplateComponent: {
                title: "",
                selectedEl: null
            },
            profileContentSections: [],
            outboundedItems: [],
            inboundItemsToBeRemoved: [],
        };
    },
    computed: {
        leftTabOptions() {
            let vm = this;
            if (vm.isApplyingProfile) {
                return [
                    {
                        title: 'Profile',
                        value: 'profile',
                    },
                    {
                        title: 'Components',
                        value: 'components',
                    },
                    {
                        title: 'Layers',
                        value: 'layers',
                    },
                    {
                        title: 'Draft',
                        value: 'draft',
                    }
                ];
            }
            return [
                {
                    title: 'Templates',
                    value: 'templates',
                },
                {
                    title: 'Components',
                    value: 'components',
                },
                {
                    title: 'Layers',
                    value: 'layers',
                },
                {
                    title: 'Draft',
                    value: 'draft',
                }
            ];
        },
        rightTabOptions() {
            let vm = this;
            if (vm.isApplyingProfile) {
                return [
                    {
                        title: 'Layout',
                        value: 'layout',
                    },
                    {
                        title: 'Format',
                        value: 'format',
                    },
                ];
            }
            return [
                {
                    title: 'Layout',
                    value: 'layout',
                },
                {
                    title: 'Format',
                    value: 'format',
                },
                {
                    title: 'Attribute',
                    value: 'attribute',
                },
            ];
        }
    },
    mounted() {
        let vm = this;
        vm.initiatePinchZoomGesture();
        vm.createNewTemplate(vm.payload);
        Array.prototype.insert = function (index, ...items) {
            this.splice(index, 0, ...items);
        };
        eventBus.$on("onElementSelected", (selectedEl) => {
            vm.loadSelectedElement(selectedEl);
        });
        eventBus.$on("onSaveNodeComponent", (selectedEl) => {
            if (selectedEl) {
                vm.showSaveNodeComponentModal(selectedEl);
            }
        });
    },
    methods: {
        templateRepair() {
            let vm = this;
            const repairs = [
                // {
                //     element: 'container_element',
                //     key: 'flexWrap',
                //     value: 'unset'
                // }
            ]
            vm.layers.forEach((page, pageIndex) => {
                page.children.forEach((item, index) => {
                    repairs.forEach((repair) => {
                        if (item.itemType == repair.element) {
                            item[repair.key] = repair.value;
                            vm.repairTemplateChildren(item.children, repair);
                        }
                    })
                })
            })
        },
        importTemplate() {
            let vm = this;
            document.getElementById('template-file-import-input').click();
        },
        onFileImported(e) {
            let vm = this;
            const file = e.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const template = e.target.result;
                    vm.duplicateTemplate({
                        cvData: template
                    });
                };
                reader.readAsText(file);
            }
        },
        repairTemplateChildren(children, repair) {
            let vm = this;
            children.forEach((item, index) => {
                if (item.itemType == repair.element) {
                    item[repair.key] = repair.value;
                    vm.repairTemplateChildren(item.children, repair);
                }
            })
        },
        onChangeTemplateVersion(version) {
            let vm = this;
            vm.show_template_versions_filter = false;
            vm.template_versions[vm.active_template_version] = structuredClone(vm.layers);
            vm.active_template_version = version;
            if (!vm.template_versions[vm.active_template_version]) {
                // Copy second page
                if (vm.layers[1]) {
                    const pageLenght = version == 'medium' ? 4 : 6;
                    for (let index = 0; index <= pageLenght; index++) {
                        let newPage = structuredClone(vm.layers[1]);
                        newPage.itemId = 'item_id_page_' + vm.$makeId(20);
                        newPage.itemName = newPage.itemName + ' copy';
                        newPage.children = vm.changeChildrenId(newPage.children);
                        vm.layers.push(newPage);

                    }
                    vm.template_versions[vm.active_template_version] = structuredClone(vm.layers);
                } else {
                    if (vm.layers[0]) {
                        const pageLenght = version == 'medium' ? 4 : 6;
                        for (let index = 0; index <= pageLenght; index++) {
                            let newPage = structuredClone(vm.layers[0]);
                            newPage.itemId = 'item_id_page_' + vm.$makeId(20);
                            newPage.itemName = newPage.itemName + ' copy';
                            newPage.children = vm.changeChildrenId(newPage.children);
                            vm.layers.push(newPage);

                        }
                        vm.template_versions[vm.active_template_version] = structuredClone(vm.layers);
                    }
                }
            }
            else {
                vm.layers = structuredClone(vm.template_versions[vm.active_template_version]);
            }
        },
        saveTemplateComponent() {
            let vm = this;
            vm.loadingSaveComponent = true;
            vm.diselectAllElements(vm.layers);
            vm.genelateElementThumb(vm.formTemplateComponent.selectedEl.itemId, (thumbBlob) => {
                let formData = new FormData();
                formData.append("title", vm.formTemplateComponent.title);
                formData.append("component", JSON.stringify(vm.formTemplateComponent.selectedEl));
                formData.append("file", thumbBlob, "component.png");
                vm.$store
                    .dispatch("CVS_ADD_NEW_COMPONENT", formData)
                    .then((response) => {
                        vm.loadingSaveComponent = false;
                        vm.showSaveComponentModal = false;
                        eventBus.$emit("onSaveNodeComponentSuccess", response.data);
                        vm.$notify({
                            group: "status",
                            title: "Messsage",
                            text: "Component has been saved successfully",
                            type: "success",
                            duration: 3000,
                        });
                    })
                    .catch((error) => {
                        vm.loadingSaveComponent = false;
                        vm.$notify({
                            group: "status",
                            title: "Message",
                            text: "Something went wrong",
                            type: "warn",
                            duration: 3000,
                        });
                        console.error({ error });
                    });
            }, () => {
                vm.loadingSaveComponent = false;
            });
        },
        showSaveNodeComponentModal(selectedEl) {
            let vm = this;
            vm.formTemplateComponent = {
                title: "",
                selectedEl: selectedEl
            };
            vm.showSaveComponentModal = true;
        },
        loadSelectedElement(selectedEl) {
            let vm = this;
            if (selectedEl) {
                let el = document.getElementById(selectedEl.itemId);
                if (el) {
                    let layerIndexPath = el.getAttribute('layer-index-path');
                    let layerIndexPathArray = JSON.parse(layerIndexPath);
                    let dectedDataOwner = 'profile';
                    const selectedElement = layerIndexPathArray.reduce((element, index, i) => {
                        if (i === 0) {
                            return vm.layers[index];
                        } else {
                            let child = element.children[index];
                            if (child && child.itemType == 'container_element' && child.dataOrigin != '' && selectedEl.itemType != 'container_element') {
                                dectedDataOwner = child.dataOrigin;
                            } else if (child && selectedEl.itemType == 'container_element' && child.itemType == 'container_element' && child.dataOrigin == 'project_skills') {
                                dectedDataOwner = 'projects';
                            } else if (child && selectedEl.itemType == 'container_element' && child.itemType == 'container_element' && child.dataOrigin == 'employment_skills') {
                                dectedDataOwner = 'employments';
                            }
                            return child;
                        }
                    }, null);
                    vm.selectedElement = selectedElement;
                    vm.selectedElement.dataOriginOwner = dectedDataOwner;
                    setTimeout(() => {
                        let pageElement = document.getElementById('layer_item_' + selectedEl.itemId);
                        if (pageElement) {
                            pageElement.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            });
                        }
                    }, 100);
                }
            } else {
                vm.selectedElement = null;
            }
            vm.diselectAllElements(vm.layers);
        },
        showSaveCvModal() {
            let vm = this;
            if (!vm.isEditingCv) {
                vm.formCV.id = null;
                vm.formCV.user_id = vm.selectedProfile.profile.profile_id;
                vm.formCV.name = "";
                vm.formCV.description = "";
            }
            vm.formCV.templateId = vm.formTemp.id;
            vm.formCV.cvData = vm.layers;
            vm.formCV.isDraft = false;
            vm.show_add_new_cv_form = true;
        },
        showSaveCvAsDraftModal() {
            let vm = this;
            if (!vm.isEditingCv) {
                vm.formCV.id = null;
                vm.formCV.user_id = vm.selectedProfile.profile.profile_id;
                vm.formCV.name = "";
                vm.formCV.description = "";
            }
            vm.formCV.templateId = vm.formTemp.id;
            vm.formCV.cvData = vm.layers;
            vm.formCV.isDraft = true;
            vm.show_add_new_cv_form = true;
        },
        saveCv() {
            let vm = this;
            vm.save_cv_loading = true;
            vm.genelateElementThumb(vm.layers[0].itemId, (thumbBlob) => {
                let formData = new FormData();
                vm.formCV.file = thumbBlob;
                formData.append("id", vm.formCV.id);
                formData.append("template_id", vm.formCV.templateId);
                formData.append("name", vm.formCV.name);
                formData.append("user_id", vm.formCV.user_id);
                formData.append("description", vm.formCV.description);
                formData.append("type", vm.account_type);
                formData.append("origin", vm.formCV.origin);
                formData.append("cvData", JSON.stringify({
                    cvData: vm.layers,
                    version: vm.templateAllowedVersion
                }));
                formData.append("file", vm.formCV.file, "cv.png");
                formData.append("isDraft", vm.formCV.isDraft);
                if (!vm.formCV.id) {
                    const saveCv = () => {
                        vm.$store
                            .dispatch("CVS_SUBMIT_CV", formData)
                            .then((response) => {
                                vm.save_cv_loading = false;
                                vm.show_add_new_cv_form = false;
                                vm.createNewTemplate();
                                vm.$notify({
                                    group: "status",
                                    title: "Messsage",
                                    text: "CV has been created successfully",
                                    type: "success",
                                    duration: 3000,
                                });
                            })
                            .catch((error) => {
                                vm.save_cv_loading = false;
                                vm.$notify({
                                    group: "status",
                                    title: "Message",
                                    text: "Something went wrong",
                                    type: "warn",
                                    duration: 3000,
                                });
                                console.error({ error });
                            });
                    };
                    if (vm.account_type == "school" && !vm.formCV.isDraft) {
                        eventBus.$emit("openDialogMessage", {
                            title: "Student approval",
                            message:
                                "<span style='color:#000;font-size:16px;font-weight:800'>" +
                                vm.selectedProfile.profile.profile_first_name +
                                " " +
                                vm.selectedProfile.profile.profile_last_name +
                                "</span>'s consent is necessary in order to upload the CV. We have informed the recipient. Following confirmation, the CV will be uploaded.",
                            action_label: "Ok",
                            action_path: "",
                            action_close_label: "",
                            callback: () => {
                                saveCv();
                            },
                        });
                    } else {
                        saveCv();
                    }
                } else {
                    vm.$store
                        .dispatch("CVS_UPDATE_CV", formData)
                        .then((response) => {
                            vm.save_cv_loading = false;
                            vm.show_add_new_cv_form = false;
                            vm.createNewTemplate();
                            vm.$notify({
                                group: "status",
                                title: "Messsage",
                                text: "CV has been updated successfully",
                                type: "success",
                                duration: 3000,
                            });
                        })
                        .catch((error) => {
                            vm.save_cv_loading = false;
                            vm.$notify({
                                group: "status",
                                title: "Message",
                                text: "Something went wrong",
                                type: "warn",
                                duration: 3000,
                            });
                            console.error({ error });
                        });
                }
            }, () => {
                vm.save_cv_loading = false;
            });
        },
        applyEffectToElementAndChildren(element) {
            let vm = this;
            // check if element is not svg
            if (element.tagName !== 'svg') {
                const attributes = element.getAttributeNames();
                for (const attribute of attributes) {
                    if (attribute !== 'style' && attribute !== 'src') {
                        element.removeAttribute(attribute);
                    }
                }
                const children = element.children;
                for (const child of children) {
                    vm.applyEffectToElementAndChildren(child);
                }
            }
        },
        downloadCv() {
            let vm = this;
            vm.isPageReadOnly = true;
            vm.loadingDownloadingCv = true;
            vm.$store.commit("SET_DOWNLOADING_CV", true);
            setTimeout(() => {
                const pageDom = vm.layers.map((item, index) => {
                    let parentPageEl = document.querySelector(`#${item.itemId}`).parentNode.cloneNode(true);
                    let pageEl = parentPageEl.querySelector(`#${item.itemId}`);
                    vm.applyEffectToElementAndChildren(pageEl);
                    pageEl.style.removeProperty("width");
                    pageEl.style.removeProperty("height");
                    pageEl.classList.add("cv-template-page");
                    return {
                        index: index,
                        page: pageEl.parentElement.innerHTML.replaceAll('<!---->', "")
                    }
                });
                vm.$store
                    .dispatch("CVS_GENELATE_FILE", {
                        pages: pageDom,
                    })
                    .then((response) => {
                        vm.loadingDownloadingCv = false;
                        vm.$store.commit("SET_DOWNLOADING_CV", false);
                        const url = FILE_MAKER_SERVER_BASE_URL + "/download/" + response.data.url;
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", "cv.pdf");
                        document.body.appendChild(link);
                        link.click();
                        vm.isPageReadOnly = false;
                    })
                    .catch((error) => {
                        vm.isPageReadOnly = true;
                        vm.loadingDownloadingCv = false;
                        vm.$store.commit("SET_DOWNLOADING_CV", false);
                    });
            }, 300);
        },
        initiatePinchZoomGesture() {
            let vm = this;
            let element = document.querySelector('.middle-panel-section-body-page');
            let scale = 1.0;
            element.addEventListener('wheel', (ev) => {
                if (ev.ctrlKey) {
                    ev.preventDefault();
                    let isPinch = Math.abs(ev.deltaY) < 50;
                    if (isPinch) {
                        // This is a pinch on a trackpad
                        let factor = 1 - 0.01 * ev.deltaY;
                        scale *= factor;
                        let parcent = Math.round(scale * 100);
                        vm.parcent_zoom = parcent;
                        vm.onChangeZoom(parcent);
                    } else {
                        // This is a mouse wheel
                        let strength = 1.4;
                        let factor = ev.deltaY < 0 ? strength : 1.0 / strength;
                        scale *= factor;
                        let parcent = Math.round(scale * 100);
                        vm.parcent_zoom = parcent;
                        vm.onChangeZoom(parcent);
                    }
                }
            });
        },
        saveEditingHistory(historyPayload) {
            let vm = this;
            if (vm.$store.state.canCVSaveHistory) {
                // Remove all history after active index
                if (vm.activeHistoryIndex < vm.historyStack.length - 1) {
                    vm.historyStack.splice(vm.activeHistoryIndex + 1, vm.historyStack.length - vm.activeHistoryIndex - 1);
                }
                // eslint-disable-next-line no-undef
                vm.historyStack.push(historyPayload);
                vm.activeHistoryIndex = vm.historyStack.length - 1;
            }
        },
        unDoEditingHistory() {
            let vm = this;
            if (vm.activeHistoryIndex > 0) {
                const history = vm.historyStack[vm.activeHistoryIndex];
                if (history.type == 'add') {
                    // Find element and remove it
                    const removedItem = vm.findElementRemoveIt(vm.layers, history.elementId);
                    if (removedItem) {
                        // Update this history
                        vm.historyStack[vm.activeHistoryIndex].deletedElement = removedItem;
                        vm.historyStack[vm.activeHistoryIndex].type = 'deleted';
                    }
                } else if (history.type == 'deleted') {
                    const elementToAdd = history.deletedElement;
                    const parentElementId = elementToAdd.itemParentId;
                    vm.findParentAndAddElement(vm.layers, parentElementId, elementToAdd);
                    // Update this history
                    vm.historyStack[vm.activeHistoryIndex].type = 'add';
                    vm.historyStack[vm.activeHistoryIndex].deletedElement = null;
                } else if (history.type == 'edit') {
                    const elementId = history.elementId;
                    vm.findElementAndEditIt(vm.layers, elementId, history.elementKey, history.elementOldValue);
                }
                vm.activeHistoryIndex -= 1;
            }
        },
        reDoEditingHistory() {
            let vm = this;
            if (vm.activeHistoryIndex < vm.historyStack.length - 1) {
                vm.activeHistoryIndex += 1;
                const history = vm.historyStack[vm.activeHistoryIndex];
                if (history.type == 'add') {
                    // Find element and remove it
                    const removedItem = vm.findElementRemoveIt(vm.layers, history.elementId);
                    if (removedItem) {
                        // Update this history
                        vm.historyStack[vm.activeHistoryIndex].deletedElement = removedItem;
                        vm.historyStack[vm.activeHistoryIndex].type = 'deleted';
                    }
                } else if (history.type == 'deleted') {
                    const elementToAdd = history.deletedElement;
                    const parentElementId = elementToAdd.itemParentId;
                    vm.findParentAndAddElement(vm.layers, parentElementId, elementToAdd);
                    // Update this history
                    vm.historyStack[vm.activeHistoryIndex].type = 'add';
                    vm.historyStack[vm.activeHistoryIndex].deletedElement = null;
                } else if (history.type == 'edit') {
                    const elementId = history.elementId;
                    vm.findElementAndEditIt(vm.layers, elementId, history.elementKey, history.elementNewValue);
                }
            }
        },
        findElementRemoveIt(children, elementId) {
            let removedItem = null;
            for (let i = 0; i < children.length; i++) {
                const child = children[i];
                if (child.itemId === elementId) {
                    removedItem = children.splice(i, 1)[0];
                    break;
                } else if (child.children) {
                    removedItem = this.findElementRemoveIt(child.children, elementId);
                    if (removedItem) {
                        break;
                    }
                }
            }
            return removedItem;
        },
        findParentAndAddElement(children, parentElementId, elementToAdd) {
            let vm = this;
            for (let i = 0; i < children.length; i++) {
                const child = children[i];
                if (child.itemId === parentElementId) {
                    child.children.push(elementToAdd);
                    break;
                } else if (child.children) {
                    vm.findParentAndAddElement(child.children, parentElementId, elementToAdd);
                }
            }
        },
        findElementAndEditIt(children, elementId, elementKey, elementValue) {
            let vm = this;
            for (let i = 0; i < children.length; i++) {
                const child = children[i];
                if (child.itemId === elementId) {
                    child[elementKey] = elementValue;
                    break;
                } else if (child.children) {
                    vm.findElementAndEditIt(child.children, elementId, elementKey, elementValue);
                }
            }
        },
        pageZoomOut() {
            let vm = this;
            if (vm.pageZoomLevel > 0.4) {
                vm.pageZoomLevel -= 0.2;
                let parcent = Math.round(vm.pageZoomLevel * 100);
                vm.parcent_zoom = parcent;
                let pageContainerWidth = 595 * vm.pageZoomLevel;
                let pageContainerHeight = 842 * vm.pageZoomLevel;
                let topPossition = -35 / vm.pageZoomLevel;
                let globalDynamicStyle = document.getElementById('globalDynamicStyle');
                let css = `:root {
            --normal-zoom: scale(${vm.pageZoomLevel});
            --inverce-zoom: scale(${1 / vm.pageZoomLevel});
            --page-container-width: ${pageContainerWidth}px;
            --page-container-height: ${pageContainerHeight}px;
            --cv-tool-options-top-possition: ${topPossition}px;
            }`;
                globalDynamicStyle.innerHTML = css;
                let pageContainer = document.querySelector('.middle-panel-section-body-page');
                // scoll horizontally to center only
                pageContainer.scrollLeft = (pageContainer.scrollWidth - pageContainer.clientWidth) / 2;


            }

        },
        pageZoomIn() {
            let vm = this;
            if (vm.pageZoomLevel < 3.4) {
                vm.pageZoomLevel += 0.2;

                let parcent = Math.round(vm.pageZoomLevel * 100);
                vm.parcent_zoom = parcent;
                let pageContainerWidth = 595 * vm.pageZoomLevel;
                let pageContainerHeight = 842 * vm.pageZoomLevel;
                let topPossition = -35 / vm.pageZoomLevel;
                let globalDynamicStyle = document.getElementById('globalDynamicStyle');
                let css = `:root {
            --normal-zoom: scale(${vm.pageZoomLevel});
            --inverce-zoom: scale(${1 / vm.pageZoomLevel});
            --page-container-width: ${pageContainerWidth}px;
            --page-container-height: ${pageContainerHeight}px;
            --cv-tool-options-top-possition: ${topPossition}px;
            }`;
                globalDynamicStyle.innerHTML = css;

                let pageContainer = document.querySelector('.middle-panel-section-body-page');
                // scoll horizontally to center only
                pageContainer.scrollLeft = (pageContainer.scrollWidth - pageContainer.clientWidth) / 2;


            }
        },
        onChangeZoom(parcent) {
            let vm = this;
            vm.pageZoomLevel = (1 * parcent) / 100;
            let pageContainerWidth = 595 * vm.pageZoomLevel;
            let pageContainerHeight = 842 * vm.pageZoomLevel;
            let topPossition = -35 / vm.pageZoomLevel;
            let globalDynamicStyle = document.getElementById('globalDynamicStyle');
            let css = `:root {
            --normal-zoom: scale(${vm.pageZoomLevel});
            --inverce-zoom: scale(${1 / vm.pageZoomLevel});
            --page-container-width: ${pageContainerWidth}px;
            --page-container-height: ${pageContainerHeight}px;
            --cv-tool-options-top-possition: ${topPossition}px;
            }`;
            globalDynamicStyle.innerHTML = css;

            let pageContainer = document.querySelector('.middle-panel-section-body-page');
            // scoll horizontally to center only
            pageContainer.scrollLeft = (pageContainer.scrollWidth - pageContainer.clientWidth) / 2;


        },
        createNewTemplate(payload = null) {
            let vm = this;
            vm.isApplyingProfile = false;
            vm.historyStack = [];
            vm.activeHistoryIndex = -1;
            vm.left_active_tab = 'templates';
            vm.formTemp = { id: null, name: "", description: "", cvData: null, thumb: null };
            vm.layers = [
                {
                    itemName: 'First page',
                    itemType: 'page_element',
                    itemId: 'item_id_page_0',
                    itemParentId: null,
                    itemSelected: false,
                    children: [
                        {
                            itemName: 'Main Container',
                            itemType: 'container_element',
                            itemId: 'item_' + vm.$makeId(20),
                            itemParentId: "item_id_page_0",
                            itemSelected: false,
                            showBoxEdjes: true,
                            isProfileContent: false,
                            width: '100%',
                            height: '100%',
                            widthSizeType: 'default',
                            heightSizeType: 'default',
                            position: 'relative',
                            top: '0px',
                            left: '0px',
                            right: '0px',
                            bottom: '0px',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            flexWrap: 'unset',
                            alignItems: 'flex-start',
                            paddingTop: '10px',
                            paddingBottom: '10px',
                            paddingLeft: '10px',
                            paddingRight: '10px',
                            marginTop: '0px',
                            marginBottom: '0px',
                            marginLeft: '0px',
                            marginRight: '0px',
                            dataOriginOwner: '',
                            dataOrigin: '',
                            numberOfItems: 1,
                            children: [],
                            borderType: 'solid',
                            borderTopSize: '0px',
                            borderTopColor: '#000000',
                            borderBottomSize: '0px',
                            borderBottomColor: '#000000',
                            borderLeftSize: '0px',
                            borderLeftColor: '#000000',
                            borderRightSize: '0px',
                            borderRightColor: '#000000',
                            borderTopLeftRadius: '0px',
                            borderTopRightRadius: '0px',
                            borderBottomLeftRadius: '0px',
                            borderBottomRightRadius: '0px',
                            backgroundColor: '#ffffff',
                            gap: '0px',
                            textColor: '#000000',
                            fontFamily: 'Arial',
                            fontWeight: '100',
                            fontStyle: 'normal',
                            textDecoration: 'none',
                            textCase: 'none',
                            fontSize: '12px',
                            textLineSpacing: '20px',
                            textAlign: 'left',
                            textValue: 'This my text',

                        }
                    ],
                    dataOriginOwner: '',
                    dataOrigin: '',
                },
            ];
            vm.template_versions[vm.active_template_version] = structuredClone(vm.layers);
            vm.selectedElement = null;
            if (payload) {
                if (payload.type == 'template') {
                    vm.loadAsTemplate(payload.data);
                    if (payload.action == 'apply') {
                        vm.applyTemplate();
                    }
                } else if (payload.type == 'cv') {
                    if (payload.action == 'editAppliedCv') {
                        vm.initiateEditCv(payload);
                    }
                }
                vm.resetEditorPayload();
            }
        },
        initiateEditCv(payload) {
            let vm = this;
            vm.formCV.id = payload.data.cv.id;
            vm.formCV.templateId = payload.data.cv.template_id;
            vm.formTemp.id = payload.data.cv.template_id;
            vm.formCV.name = payload.data.cv.name;
            vm.formCV.user_id = payload.data.cv.user_id;
            vm.formCV.description = payload.data.cv.description;
            vm.formCV.isDraft = payload.data.cv.isDraft;
            vm.editAppliedCv({ ...payload.data, template: payload.data.default }, true);
        },
        resetEditorPayload() {
            let vm = this;
            vm.$emit('resetEditorPayload');
        },
        loadAsTemplate(template) {
            let vm = this;
            let cvData = JSON.parse(template.cvData);
            if (cvData.version == vm.templateAllowedVersion) {
                vm.layers = cvData.default;
                vm.active_template_version = 'default'
                vm.template_versions.default = cvData.default;
                vm.template_versions.medium = cvData.medium;
                vm.template_versions.extended = cvData.extended;
                vm.formTemp.id = template.id;
                vm.formTemp.name = template.name;
                vm.formTemp.description = template.description;
                vm.formTemp.cvData = vm.layers;
                vm.formTemp.thumb = null;
            } else {
                vm.$notify({
                    group: "status",
                    title: "Message",
                    text: "This template is not supported.",
                    type: "warn",
                    duration: 3000,
                });
            }
        },
        duplicateTemplate(template) {
            let vm = this;
            vm.loadAsTemplate(template);
            vm.formTemp.id = null;
        },
        applyTemplate() {
            let vm = this;
            if (!vm.formTemp.id) {
                vm.applyBeforeSaveTempWarn = true;
                vm.show_template_form = true;
                return;
            }
            vm.applyBeforeSaveTempWarn = false;
            vm.show_apply_profile_modal = true;
        },
        onClickOutsideOfPage() {
            let vm = this;
            vm.diselectAllElements(vm.layers);
        },
        backToCvs() {
            let vm = this;
            vm.$emit('switchSection', 1);
        },
        onToolSelected(data) {
            let vm = this;
            vm.selectedTool = data;
        },
        diselectAllElements(layers) {
            let vm = this;
            layers.forEach((layer) => {
                layer.itemSelected = false;
                if (layer.children?.length > 0) {
                    vm.diselectAllElements(layer.children);
                }
            });
        },
        onPageContainerMouseover(e) {
            e.preventDefault();
            let vm = this;
            vm.isPageContainerHover = true;
        },
        onPageContainerMouseleave(e) {
            e.preventDefault();
            let vm = this;
            vm.isPageContainerHover = false;
        },
        onPageSelected(page) {
            let vm = this;
            vm.selectedElement = page;
            vm.diselectAllElements(vm.layers);
        },
        onPageContainerMouseup(e) {
            e.preventDefault();
            let vm = this;
            if (vm.selectedTool) {
                vm.diselectAllElements(vm.layers);
                let hoveredElement = null;
                if (e.target.nodeName === 'IMG') {
                    hoveredElement = e.target.parentElement;
                } else {
                    // check if target has  data atribute of is-text that has text of `true`
                    if (e.target.getAttribute('data-is-text') == 'true') {
                        hoveredElement = e.target.parentElement;
                    } else {
                        hoveredElement = e.target;
                    }
                }
                let layerType = hoveredElement.getAttribute('layer-type');
                let layerIndex = hoveredElement.getAttribute('layer-index');
                let layerLevel = hoveredElement.getAttribute('layer-level');
                let layerParentType = hoveredElement.getAttribute('layer-parent-type');
                let layerParentIndex = hoveredElement.getAttribute('layer-parent-index');
                let layerIndexPath = hoveredElement.getAttribute('layer-index-path');
                let layerIndexPathArray = JSON.parse(layerIndexPath);
                let layerIndexPathArrayWithoutLastIndex = layerIndexPathArray.slice(0, layerIndexPathArray.length - 1);
                const selectedParentElement = layerType == "page_element" || layerType == "container_element" ? layerIndexPathArray.reduce((element, index, i) => {
                    if (i === 0) {
                        return vm.layers[index];
                    } else {
                        return element.children[index];
                    }
                }, null) : layerIndexPathArrayWithoutLastIndex.reduce((element, index, i) => {
                    if (i === 0) {
                        return vm.layers[index];
                    } else {
                        return element.children[index];
                    }
                }, null);
                let newElement = null;
                if (vm.selectedTool.origin == 'default') {
                    if (vm.selectedTool.tool.toolType == "text_tool" || vm.selectedTool.tool.toolType == "title_tool") {
                        newElement = {
                            itemName: vm.selectedTool.tool.toolType == "title_tool" ? 'Title' : 'Paragraph',
                            itemType: 'text_element',
                            itemId: 'item_' + vm.$makeId(20),
                            itemParentId: selectedParentElement.itemId,
                            itemSelected: false,
                            width: '100%',
                            height: '100%',
                            widthSizeType: 'default',
                            heightSizeType: 'default',
                            position: 'relative',
                            top: '0px',
                            left: '0px',
                            right: '0px',
                            bottom: '0px',
                            textColor: '#000000',
                            fontFamily: 'Arial',
                            fontWeight: '100',
                            fontStyle: 'normal',
                            textDecoration: 'none',
                            textCase: 'none',
                            fontSize: vm.selectedTool.tool.toolType == "title_tool" ? '20px' : '12px',
                            textLineSpacing: '17px',
                            textValue: vm.selectedTool.tool.toolType == "title_tool" ? 'Add a heading' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut auctor, nisl quis tincidunt ultricies, nunc nisl aliquam nunc',
                            textAlign: 'left',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            paddingTop: '0px',
                            paddingBottom: '0px',
                            paddingLeft: '0px',
                            paddingRight: '0px',
                            marginTop: '0px',
                            marginBottom: '0px',
                            marginLeft: '0px',
                            marginRight: '0px',
                            dataOriginOwner: '',
                            dataOrigin: '',
                            borderType: 'solid',
                            borderTopSize: '0px',
                            borderTopColor: '#000000',
                            borderBottomSize: '0px',
                            borderBottomColor: '#000000',
                            borderLeftSize: '0px',
                            borderLeftColor: '#000000',
                            borderRightSize: '0px',
                            borderRightColor: '#000000',
                            borderTopLeftRadius: '0px',
                            borderTopRightRadius: '0px',
                            borderBottomLeftRadius: '0px',
                            borderBottomRightRadius: '0px',
                            backgroundColor: '#ffffff',
                            gap: '0px',
                        };
                    } else if (vm.selectedTool.tool.toolType == "image_tool") {
                        newElement = {
                            itemName: 'Image',
                            itemType: 'image_element',
                            itemId: 'item_' + vm.$makeId(20),
                            itemParentId: selectedParentElement.itemId,
                            itemSelected: false,
                            width: '50px',
                            height: '50px',
                            widthSizeType: 'default',
                            heightSizeType: 'default',
                            position: 'relative',
                            top: '0px',
                            left: '0px',
                            right: '0px',
                            bottom: '0px',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',
                            paddingTop: '1px',
                            paddingBottom: '1px',
                            paddingLeft: '1px',
                            paddingRight: '1px',
                            marginTop: '0px',
                            marginBottom: '0px',
                            marginLeft: '0px',
                            marginRight: '0px',
                            imageSrc: SITE_API + "/super-manager/cvs/image/download?name=avatar.png",
                            imageFit: 'cover',
                            dataOriginOwner: '',
                            dataOrigin: '',
                            borderType: 'solid',
                            borderTopSize: '0px',
                            borderTopColor: '#000000',
                            borderBottomSize: '0px',
                            borderBottomColor: '#000000',
                            borderLeftSize: '0px',
                            borderLeftColor: '#000000',
                            borderRightSize: '0px',
                            borderRightColor: '#000000',
                            borderTopLeftRadius: '0px',
                            borderTopRightRadius: '0px',
                            borderBottomLeftRadius: '0px',
                            borderBottomRightRadius: '0px',
                            backgroundColor: '#ffffff',
                            gap: '0px',
                            textColor: '#000000',
                            fontFamily: 'Arial',
                            fontWeight: '100',
                            fontStyle: 'normal',
                            textDecoration: 'none',
                            textCase: 'none',
                            fontSize: '12px',
                            textLineSpacing: '20px',
                            textValue: 'This my text',
                            textAlign: 'left',

                        };

                    }
                    else if (vm.selectedTool.tool.toolType == "box_tool" || vm.selectedTool.tool.toolType == "section_tool") {
                        newElement = {
                            itemName: vm.selectedTool.tool.toolType == "section_tool" ? 'Section' : 'Box',
                            itemType: 'container_element',
                            itemId: 'item_' + vm.$makeId(20),
                            itemParentId: selectedParentElement.itemId,
                            itemSelected: false,
                            showBoxEdjes: true,
                            isProfileContent: false,
                            width: '100%',
                            height: vm.selectedTool.tool.toolType == "section_tool" ? '120px' : '80px',
                            widthSizeType: 'default',
                            heightSizeType: 'default',
                            position: 'relative',
                            top: '0px',
                            left: '0px',
                            right: '0px',
                            bottom: '0px',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            flexWrap: 'unset',
                            alignItems: 'flex-start',
                            paddingTop: '10px',
                            paddingBottom: '10px',
                            paddingLeft: '10px',
                            paddingRight: '10px',
                            marginTop: '0px',
                            marginBottom: '0px',
                            marginLeft: '0px',
                            marginRight: '0px',
                            dataOriginOwner: '',
                            dataOrigin: '',
                            numberOfItems: 1,
                            children: [],
                            borderType: 'solid',
                            borderTopSize: '0px',
                            borderTopColor: '#000000',
                            borderBottomSize: '0px',
                            borderBottomColor: '#000000',
                            borderLeftSize: '0px',
                            borderLeftColor: '#000000',
                            borderRightSize: '0px',
                            borderRightColor: '#000000',
                            borderTopLeftRadius: '0px',
                            borderTopRightRadius: '0px',
                            borderBottomLeftRadius: '0px',
                            borderBottomRightRadius: '0px',
                            backgroundColor: '#ffffff',
                            gap: '0px',
                            textColor: '#000000',
                            fontFamily: 'Arial',
                            fontWeight: '100',
                            fontStyle: 'normal',
                            textDecoration: 'none',
                            textCase: 'none',
                            fontSize: '12px',
                            textLineSpacing: '20px',
                            textAlign: 'left',
                            textValue: 'This my text',
                        };
                    } else if (vm.selectedTool.tool.toolType == "line_tool") {
                        newElement = {
                            itemName: 'Line',
                            itemType: 'line_element',
                            itemId: 'item_' + vm.$makeId(20),
                            itemParentId: selectedParentElement.itemId,
                            itemSelected: false,
                            showBoxEdjes: true,
                            width: '100%',
                            height: '2px',
                            widthSizeType: 'default',
                            heightSizeType: 'default',
                            position: 'relative',
                            top: '0px',
                            left: '0px',
                            right: '0px',
                            bottom: '0px',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',
                            paddingTop: '10px',
                            paddingBottom: '10px',
                            paddingLeft: '10px',
                            paddingRight: '10px',
                            marginTop: '0px',
                            marginBottom: '0px',
                            marginLeft: '0px',
                            marginRight: '0px',
                            dataOriginOwner: '',
                            dataOrigin: '',
                            numberOfItems: 1,
                            children: [],
                            borderType: 'solid',
                            borderTopSize: '0px',
                            borderTopColor: '#000000',
                            borderBottomSize: '0px',
                            borderBottomColor: '#000000',
                            borderLeftSize: '0px',
                            borderLeftColor: '#000000',
                            borderRightSize: '0px',
                            borderRightColor: '#000000',
                            borderTopLeftRadius: '0px',
                            borderTopRightRadius: '0px',
                            borderBottomLeftRadius: '0px',
                            borderBottomRightRadius: '0px',
                            backgroundColor: '#000',
                            gap: '0px',
                            textColor: '#000000',
                            fontFamily: 'Arial',
                            fontWeight: '100',
                            fontStyle: 'normal',
                            textDecoration: 'none',
                            textCase: 'none',
                            fontSize: '12px',
                            textLineSpacing: '20px',
                            textAlign: 'left',
                            textValue: 'This my text',
                        };
                    } else if (vm.selectedTool.tool.toolType == "star_tool") {
                        newElement = {
                            itemName: 'Ratting Star',
                            itemType: 'star_element',
                            itemId: 'item_' + vm.$makeId(20),
                            itemParentId: selectedParentElement.itemId,
                            itemSelected: false,
                            showBoxEdjes: true,
                            width: '100px',
                            height: 'max-content',
                            widthSizeType: 'default',
                            heightSizeType: 'default',
                            position: 'relative',
                            top: '0px',
                            left: '0px',
                            right: '0px',
                            bottom: '0px',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',
                            paddingTop: '0px',
                            paddingBottom: '0px',
                            paddingLeft: '0px',
                            paddingRight: '0px',
                            marginTop: '0px',
                            marginBottom: '0px',
                            marginLeft: '0px',
                            marginRight: '0px',
                            dataOriginOwner: '',
                            dataOrigin: '',
                            numberOfItems: 3,
                            children: [],
                            borderType: 'solid',
                            borderTopSize: '0px',
                            borderTopColor: '#000000',
                            borderBottomSize: '0px',
                            borderBottomColor: '#000000',
                            borderLeftSize: '0px',
                            borderLeftColor: '#000000',
                            borderRightSize: '0px',
                            borderRightColor: '#000000',
                            borderTopLeftRadius: '0px',
                            borderTopRightRadius: '0px',
                            borderBottomLeftRadius: '0px',
                            borderBottomRightRadius: '0px',
                            backgroundColor: '#000',
                            gap: '0px',
                            textColor: '#000000',
                            fontFamily: 'Arial',
                            fontWeight: '100',
                            fontStyle: 'normal',
                            textDecoration: 'none',
                            textCase: 'none',
                            fontSize: '12px',
                            textLineSpacing: '20px',
                            textAlign: 'left',
                            textValue: 'This my text',
                        };
                    }
                } else if (vm.selectedTool.origin == 'custom') {
                    vm.selectedTool.tool.itemId = 'item_id_' + vm.$makeId(20);
                    vm.selectedTool.tool.itemName = vm.selectedTool.tool.itemName + ' copy';
                    vm.selectedTool.tool.children = vm.changeChildrenId(vm.selectedTool.tool.children);
                    newElement = vm.selectedTool.tool;
                }
                if (layerType == "page_element" || layerType == "container_element") {
                    selectedParentElement.children.push(newElement);
                } else {
                    selectedParentElement.children.splice(parseInt(layerIndex) + 1, 0, newElement);
                }
                const historyPayload = {
                    type: 'add',
                    elementId: newElement.itemId,
                    elementKey: '',
                    elementNewValue: '',
                    elementOldValue: '',
                    deletedElement: null,
                }
                this.saveEditingHistory(historyPayload);

            }
        },
        onPositionTypeChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'position',
                elementNewValue: value,
                elementOldValue: this.selectedElement.position.slice(),
                deletedElement: null,
            }
            this.selectedElement.position = value;
            this.saveEditingHistory(historyPayload);
        },
        onPositionTopValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'top',
                elementNewValue: value,
                elementOldValue: this.selectedElement.top.slice(),
                deletedElement: null,
            }
            this.selectedElement.top = value;
            this.saveEditingHistory(historyPayload);
        },
        onPositionBottomValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'bottom',
                elementNewValue: value,
                elementOldValue: this.selectedElement.bottom.slice(),
                deletedElement: null,
            }
            this.selectedElement.bottom = value;
            this.saveEditingHistory(historyPayload);
        },
        onPositionRightValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'right',
                elementNewValue: value,
                elementOldValue: this.selectedElement.right.slice(),
                deletedElement: null,
            }
            this.selectedElement.right = value;
            this.saveEditingHistory(historyPayload);
        },
        onPositionLeftValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'left',
                elementNewValue: value,
                elementOldValue: this.selectedElement.left.slice(),
                deletedElement: null,
            }
            this.selectedElement.left = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementWidthValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'width',
                elementNewValue: value,
                elementOldValue: this.selectedElement.width.slice(),
                deletedElement: null,
            }
            this.selectedElement.width = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementHeightValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'height',
                elementNewValue: value,
                elementOldValue: this.selectedElement.height.slice(),
                deletedElement: null,
            }
            this.selectedElement.height = value;
            this.saveEditingHistory(historyPayload);
        },
        onWidthSizeTypeValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'widthSizeType',
                elementNewValue: value,
                elementOldValue: this.selectedElement.widthSizeType.slice(),
                deletedElement: null,
            }
            this.selectedElement.widthSizeType = value;
            this.saveEditingHistory(historyPayload);
        },
        onHeightSizeTypeValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'heightSizeType',
                elementNewValue: value,
                elementOldValue: this.selectedElement.heightSizeType.slice(),
                deletedElement: null,
            }
            this.selectedElement.heightSizeType = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementLayoutTypeValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'display',
                elementNewValue: value,
                elementOldValue: this.selectedElement.display.slice(),
                deletedElement: null,
            }
            this.selectedElement.display = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementLayoutDirectionValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'flexDirection',
                elementNewValue: value,
                elementOldValue: this.selectedElement.flexDirection.slice(),
                deletedElement: null,
            }
            this.selectedElement.flexDirection = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementLayoutDistributeValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'justifyContent',
                elementNewValue: value,
                elementOldValue: this.selectedElement.justifyContent.slice(),
                deletedElement: null,
            }
            this.selectedElement.justifyContent = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementLayoutAlignValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'alignItems',
                elementNewValue: value,
                elementOldValue: this.selectedElement.alignItems.slice(),
                deletedElement: null,
            }
            this.selectedElement.alignItems = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementLayoutGapValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'gap',
                elementNewValue: value,
                elementOldValue: this.selectedElement.gap.slice(),
                deletedElement: null,
            }
            this.selectedElement.gap = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementLayoutPaddingTopValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'paddingTop',
                elementNewValue: value,
                elementOldValue: this.selectedElement.paddingTop.slice(),
                deletedElement: null,
            }
            this.selectedElement.paddingTop = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementLayoutPaddingBottomValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'paddingBottom',
                elementNewValue: value,
                elementOldValue: this.selectedElement.paddingBottom.slice(),
                deletedElement: null,
            }
            this.selectedElement.paddingBottom = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementLayoutPaddingLeftValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'paddingLeft',
                elementNewValue: value,
                elementOldValue: this.selectedElement.paddingLeft.slice(),
                deletedElement: null,
            }
            this.selectedElement.paddingLeft = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementLayoutPaddingRightValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'paddingRight',
                elementNewValue: value,
                elementOldValue: this.selectedElement.paddingRight.slice(),
                deletedElement: null,
            }
            this.selectedElement.paddingRight = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementLayoutMarginTopValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'marginTop',
                elementNewValue: value,
                elementOldValue: this.selectedElement.marginTop.slice(),
                deletedElement: null,
            }
            this.selectedElement.marginTop = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementLayoutMarginBottomValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'marginBottom',
                elementNewValue: value,
                elementOldValue: this.selectedElement.marginBottom.slice(),
                deletedElement: null,
            }
            this.selectedElement.marginBottom = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementLayoutMarginLeftValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'marginLeft',
                elementNewValue: value,
                elementOldValue: this.selectedElement.marginLeft.slice(),
                deletedElement: null,
            }
            this.selectedElement.marginLeft = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementLayoutMarginRightValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'marginRight',
                elementNewValue: value,
                elementOldValue: this.selectedElement.marginRight.slice(),
                deletedElement: null,
            }
            this.selectedElement.marginRight = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementBorderTypeValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'borderType',
                elementNewValue: value,
                elementOldValue: this.selectedElement.borderType.slice(),
                deletedElement: null,
            }
            this.selectedElement.borderType = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementBorderTopSizeValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'borderTopSize',
                elementNewValue: value,
                elementOldValue: this.selectedElement.borderTopSize.slice(),
                deletedElement: null,
            }
            this.selectedElement.borderTopSize = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementBorderTopColorValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'borderTopColor',
                elementNewValue: value,
                elementOldValue: this.selectedElement.borderTopColor.slice(),
                deletedElement: null,
            }
            this.selectedElement.borderTopColor = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementBorderBottomSizeValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'borderBottomSize',
                elementNewValue: value,
                elementOldValue: this.selectedElement.borderBottomSize.slice(),
                deletedElement: null,
            }
            this.selectedElement.borderBottomSize = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementBorderBottomColorValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'borderBottomColor',
                elementNewValue: value,
                elementOldValue: this.selectedElement.borderBottomColor.slice(),
                deletedElement: null,
            }
            this.selectedElement.borderBottomColor = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementBorderLeftSizeValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'borderLeftSize',
                elementNewValue: value,
                elementOldValue: this.selectedElement.borderLeftSize.slice(),
                deletedElement: null,
            }
            this.selectedElement.borderLeftSize = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementBorderLeftColorValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'borderLeftColor',
                elementNewValue: value,
                elementOldValue: this.selectedElement.borderLeftColor.slice(),
                deletedElement: null,
            };
            this.selectedElement.borderLeftColor = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementBorderRightSizeValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'borderRightSize',
                elementNewValue: value,
                elementOldValue: this.selectedElement.borderRightSize.slice(),
                deletedElement: null,
            };
            this.selectedElement.borderRightSize = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementBorderRightColorValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'borderRightColor',
                elementNewValue: value,
                elementOldValue: this.selectedElement.borderRightColor.slice(),
                deletedElement: null,
            };
            this.selectedElement.borderRightColor = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementBorderTopLeftRadiusValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'borderTopLeftRadius',
                elementNewValue: value,
                elementOldValue: this.selectedElement.borderTopLeftRadius.slice(),
                deletedElement: null,
            };
            this.selectedElement.borderTopLeftRadius = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementBorderTopRightRadiusValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'borderTopRightRadius',
                elementNewValue: value,
                elementOldValue: this.selectedElement.borderTopRightRadius.slice(),
                deletedElement: null,
            };
            this.selectedElement.borderTopRightRadius = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementBorderBottomLeftRadiusValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'borderBottomLeftRadius',
                elementNewValue: value,
                elementOldValue: this.selectedElement.borderBottomLeftRadius.slice(),
                deletedElement: null,
            };
            this.selectedElement.borderBottomLeftRadius = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementBorderBottomRightRadiusValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'borderBottomRightRadius',
                elementNewValue: value,
                elementOldValue: this.selectedElement.borderBottomRightRadius.slice(),
                deletedElement: null,
            };
            this.selectedElement.borderBottomRightRadius = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementBackgoundColorValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'backgroundColor',
                elementNewValue: value,
                elementOldValue: this.selectedElement.backgroundColor.slice(),
                deletedElement: null,
            };
            this.selectedElement.backgroundColor = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementTextColorValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'textColor',
                elementNewValue: value,
                elementOldValue: this.selectedElement.textColor.slice(),
                deletedElement: null,
            };
            this.selectedElement.textColor = value;
            this.saveEditingHistory(historyPayload);
        },
        onTextFontFamilyChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'fontFamily',
                elementNewValue: value,
                elementOldValue: this.selectedElement.fontFamily.slice(),
                deletedElement: null,
            };
            this.selectedElement.fontFamily = value;
            this.saveEditingHistory(historyPayload);
        },
        onTextFontWeightChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'fontWeight',
                elementNewValue: value,
                elementOldValue: this.selectedElement.fontWeight.slice(),
                deletedElement: null,
            };
            this.selectedElement.fontWeight = value;
            this.saveEditingHistory(historyPayload);
        },
        onTextFontStyleChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'fontStyle',
                elementNewValue: value,
                elementOldValue: this.selectedElement.fontStyle.slice(),
                deletedElement: null,
            };
            this.selectedElement.fontStyle = value;
            this.saveEditingHistory(historyPayload);
        },
        onTextDecorationChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'textDecoration',
                elementNewValue: value,
                elementOldValue: this.selectedElement.textDecoration.slice(),
                deletedElement: null,
            };
            this.selectedElement.textDecoration = value;
            this.saveEditingHistory(historyPayload);
        },
        onTextCaseChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'textCase',
                elementNewValue: value,
                elementOldValue: this.selectedElement.textCase.slice(),
                deletedElement: null,
            };
            this.selectedElement.textCase = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementTextSizeValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'fontSize',
                elementNewValue: value,
                elementOldValue: this.selectedElement.fontSize.slice(),
                deletedElement: null,
            };
            this.selectedElement.fontSize = value;
            this.saveEditingHistory(historyPayload);
        },
        onTextLineSpacingChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'textLineSpacing',
                elementNewValue: value,
                elementOldValue: this.selectedElement.textLineSpacing.slice(),
                deletedElement: null,
            };
            this.selectedElement.textLineSpacing = value;
            this.saveEditingHistory(historyPayload);
        },
        onTextContentChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'textValue',
                elementNewValue: value,
                elementOldValue: this.selectedElement.textValue.slice(),
                deletedElement: null,
            };
            this.selectedElement.textValue = value;
            this.saveEditingHistory(historyPayload);
        },
        onTextAlignValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'textAlign',
                elementNewValue: value,
                elementOldValue: this.selectedElement.textAlign.slice(),
                deletedElement: null,
            };
            this.selectedElement.textAlign = value;
            this.saveEditingHistory(historyPayload);
        },
        onProfileContentValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'isProfileContent',
                elementNewValue: value,
                elementOldValue: this.selectedElement.isProfileContent.slice(),
                deletedElement: null,
            };
            this.selectedElement.isProfileContent = value;
            this.saveEditingHistory(historyPayload);
        },
        onElementWrapContentValueChange(value) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'flexWrap',
                elementNewValue: value,
                elementOldValue: this.selectedElement.flexWrap.slice(),
                deletedElement: null,
            };
            this.selectedElement.flexWrap = value;
            this.saveEditingHistory(historyPayload);
        },
        onImageSelected(url) {
            const historyPayload = {
                type: 'edit',
                elementId: this.selectedElement.itemId,
                elementKey: 'imageSrc',
                elementNewValue: url,
                elementOldValue: this.selectedElement.imageSrc.slice(),
                deletedElement: null,
            };
            let vm = this;
            vm.selectedElement.imageSrc = url;
            vm.saveEditingHistory(historyPayload);
        },
        // Data Binding
        onDataOriginChange(value) {
            this.selectedElement.dataOriginOwner = value.dataOriginOwner;
            this.selectedElement.dataOrigin = value.dataOrigin;

        },
        onNumberItemsChange(value) {
            this.selectedElement.numberOfItems = value;

        },
        onDeleteElement(page, index) {
            let vm = this;
            vm.selectedElement = null;
            page.children.splice(index, 1);
        },
        // Template functions
        showSaveTemplateModal() {
            let vm = this;
            vm.show_template_form = true;
        },
        clearData(layers, trashData) {
            let vm = this;
            if (layers) {
                return layers.map((layer) => {
                    trashData.forEach((trash) => {
                        delete layer[trash];
                    });
                    if (layer.children?.length > 0) {
                        vm.clearData(layer.children, trashData);
                    }
                    return layer;
                });
            }
            return layers;
        },
        saveTemplate() {
            let vm = this;
            vm.save_template_loading = true;
            vm.diselectAllElements(vm.layers);
            vm.templateRepair();
            // eslint-disable-next-line no-undef
            vm.template_versions[vm.active_template_version] = structuredClone(vm.layers);
            let trashData = ['parent'];
            vm.template_versions.default = vm.clearData(vm.template_versions.default, trashData);
            vm.template_versions.medium = vm.clearData(vm.template_versions.medium, trashData);
            vm.template_versions.extended = vm.clearData(vm.template_versions.extended, trashData);

            vm.genelateElementThumb(vm.layers[0].itemId, (thumbBlob) => {
                vm.formTemp.cvData = {
                    ...vm.template_versions,
                    version: vm.templateAllowedVersion,
                };
                vm.formTemp.thumb = thumbBlob;
                let formData = new FormData();
                formData.append("id", vm.formTemp.id);
                formData.append("name", vm.formTemp.name);
                formData.append("description", vm.formTemp.description);
                formData.append("cvData", JSON.stringify(vm.formTemp.cvData));
                formData.append("thumb", vm.formTemp.thumb, "template.png");
                formData.append("type", ACCOUNT_TYPE);

                if (!vm.formTemp.id) {
                    vm.$store
                        .dispatch("CVS_ADD_NEW_TEMPLATE", formData)
                        .then((response) => {
                            vm.formTemp.id = response.data.id;
                            vm.save_template_loading = false;
                            vm.show_template_form = false;
                            eventBus.$emit("loadEditorTemplate");
                            if (vm.applyBeforeSaveTempWarn) {
                                vm.applyBeforeSaveTempWarn = false;
                                vm.show_apply_profile_modal = true;
                            }
                            vm.$notify({
                                group: "status",
                                title: "Messsage",
                                text: "Saved As template",
                                type: "success",
                                duration: 3000,
                            });
                        })
                        .catch((error) => {
                            vm.save_template_loading = false;
                            vm.$notify({
                                group: "status",
                                title: "Message",
                                text: "Something went wrong",
                                type: "warn",
                                duration: 3000,
                            });
                            console.error({ error });
                        });
                } else {
                    vm.$store
                        .dispatch("CVS_UPDATE_TEMPLATE", formData)
                        .then((response) => {
                            vm.save_template_loading = false;
                            vm.show_template_form = false;
                            eventBus.$emit("loadEditorTemplate");
                            vm.$notify({
                                group: "status",
                                title: "Messsage",
                                text: "All changes are saved",
                                type: "success",
                                duration: 3000,
                            });
                        })
                        .catch((error) => {
                            vm.save_template_loading = false;
                            vm.$notify({
                                group: "status",
                                title: "Message",
                                text: "Something went wrong",
                                type: "warn",
                                duration: 3000,
                            });
                            console.error({ error });
                        });
                }

            }, () => {
                vm.save_template_loading = false;
            });

        },
        genelateElementThumb(elementId, successCallback, failCallback) {
            let vm = this;
            let pageEl = document.getElementById(elementId);
            domtoimage
                .toJpeg(pageEl, {
                    quality: 1,
                    pixelRatio: 0.5,
                })
                .then(function (dataUrl) {
                    let thumbBlob = vm.dataURItoBlob(dataUrl);
                    successCallback(thumbBlob);
                })
                .catch(function (error) {
                    failCallback();
                    console.error(error);
                });
        },
        // Page functions
        duplicatePage(page) {
            let vm = this;
            vm.diselectAllElements(vm.layers);
            vm.selectedElement = null;
            let newPage = structuredClone(page);
            newPage.itemId = 'item_id_page_' + vm.$makeId(20);
            newPage.itemName = newPage.itemName + ' copy';
            newPage.children = vm.changeChildrenId(newPage.children);
            vm.layers.push(newPage);
            setTimeout(() => {
                let pageElement = document.getElementById(newPage.itemId + '_page_options');
                pageElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }, 100);
        },
        changeChildrenId(items) {
            let vm = this;
            return items.map(item => {
                item.itemId = 'item_id_' + vm.$makeId(20);
                if (item.children) {
                    item.children = vm.changeChildrenId(item.children);
                }
                return item;
            });
        },
        deletePage(page, index) {
            let vm = this;
            vm.selectedElement = null;
            vm.diselectAllElements(vm.layers);
            if (confirm('Do you want to delete this page?')) {
                vm.layers.splice(index, 1);
            }
        },
        newPage(page) {
            let vm = this;
            vm.selectedElement = null;
            vm.diselectAllElements(vm.layers);
            let newPage = JSON.parse(JSON.stringify(page));
            newPage.itemId = 'item_id_page_' + vm.$makeId(20);
            newPage.itemName = 'New Page';
            newPage.itemSelected = false;
            newPage.children = [
                {
                    itemName: 'Main Container',
                    itemType: 'container_element',
                    itemId: 'item_' + vm.$makeId(20),
                    itemParentId: newPage.itemId,
                    itemSelected: false,
                    showBoxEdjes: true,
                    width: '100%',
                    height: '100%',
                    widthSizeType: 'default',
                    heightSizeType: 'default',
                    position: 'relative',
                    top: '0px',
                    left: '0px',
                    right: '0px',
                    bottom: '0px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    flexWrap: 'unset',
                    alignItems: 'flex-start',
                    paddingTop: '10px',
                    paddingBottom: '10px',
                    paddingLeft: '10px',
                    paddingRight: '10px',
                    marginTop: '0px',
                    marginBottom: '0px',
                    marginLeft: '0px',
                    marginRight: '0px',
                    dataOriginOwner: '',
                    dataOrigin: '',
                    numberOfItems: 1,
                    children: [],
                    borderType: 'solid',
                    borderTopSize: '0px',
                    borderTopColor: '#000000',
                    borderBottomSize: '0px',
                    borderBottomColor: '#000000',
                    borderLeftSize: '0px',
                    borderLeftColor: '#000000',
                    borderRightSize: '0px',
                    borderRightColor: '#000000',
                    borderTopLeftRadius: '0px',
                    borderTopRightRadius: '0px',
                    borderBottomLeftRadius: '0px',
                    borderBottomRightRadius: '0px',
                    backgroundColor: '#ffffff',
                    gap: '0px',
                    textColor: '#000000',
                    fontFamily: 'Arial',
                    fontWeight: '100',
                    fontStyle: 'normal',
                    textDecoration: 'none',
                    textCase: 'none',
                    fontSize: '12px',
                    textLineClamp: 1,
                    textLineSpacing: '20px',
                    textAlign: 'left',
                    textValue: 'This my text',
                }
            ]
            vm.layers.push(newPage);
            setTimeout(() => {
                let pageElement = document.getElementById(newPage.itemId + '_page_options');
                pageElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }, 100);
        },
        editAppliedCv(data, editStatus) {
            let vm = this;
            vm.isApplyingProfile = true;
            vm.isEditingCv = editStatus;
            vm.show_apply_profile_modal = false;
            vm.left_active_tab = 'profile';
            // eslint-disable-next-line no-undef
            vm.layers = structuredClone(data.layers);
            vm.selectedTemplate = data.template;
            vm.formCV.templateId = vm.formTemp.id;
            vm.selectedProfile = data.profile;

            vm.layers.forEach((page, index) => {
                vm.$nextTick(() => {
                    vm.fitPageContent(index);
                });
            });
        },
        // ==========
        fitPageContent(pageIndex = 0) {
            let vm = this;
            vm.profileContentSections = [];
            vm.getProfileContentSections(null, pageIndex);
            vm.outboundedItems = [];
            vm.inboundItemsToBeRemoved = [];
            let page = vm.layers[pageIndex];
            let pageDomEl = document.querySelector(`#${page.itemId}`);
            let pageRect = pageDomEl.getBoundingClientRect();
            vm.profileContentSections.forEach(item => {
                let profileContentSectionChildren = item.children;
                profileContentSectionChildren.forEach(itemChild => {
                    let child = document.querySelector(`#${itemChild.itemId}`);
                    let otherElementRect = child.getBoundingClientRect();

                    let isTopOutOfViewport = pageRect.bottom < otherElementRect.top;
                    if (isTopOutOfViewport) {
                        let outBoundItem = {
                            parentItemId: item.itemId,
                            isMainSestion: true,
                            item: itemChild,
                        }
                        vm.outboundedItems.push(outBoundItem);
                    } else {
                        let isBottomOutOfViewport = pageRect.bottom < otherElementRect.bottom;
                        if (isBottomOutOfViewport && itemChild.itemType == 'container_element') {
                            itemChild['foundItemOutbounded'] = false;
                            itemChild['foundItemInbounded'] = false;
                            vm.analizeItemsOutOfViewport(itemChild, itemChild, itemChild.children, pageRect);

                            if (!itemChild.foundItemOutbounded) {
                                vm.inboundItemsToBeRemoved.push({
                                    parentItemId: item.itemId,
                                    item: itemChild,
                                });
                            }

                            if (!itemChild.foundItemInbounded) {
                                let outBoundItem = {
                                    parentItemId: item.itemId,
                                    item: itemChild,
                                }
                                vm.outboundedItems.push(outBoundItem);
                            }

                        } else {
                            if (itemChild.itemType == 'container_element') {
                                vm.inboundItemsToBeRemoved.push({
                                    parentItemId: item.itemId,
                                    item: itemChild,
                                });
                            }
                        }
                    }
                });
            });

            if (vm.outboundedItems.length > 0) {
                vm.removeOutboundedItems(page.children);
                vm.prepareNextPage(pageIndex);
                vm.$nextTick(() => {
                    vm.fitPageContent(pageIndex + 1);
                });
            }
        },
        prepareNextPage(pageIndex = 0) {
            let vm = this;
            let pageContent = vm.layers[pageIndex];
            vm.fittingDuplicatePage(pageContent, pageIndex);
        },
        fittingDuplicatePage(page, pageIndex) {
            let vm = this;
            // eslint-disable-next-line no-undef
            let newPage = structuredClone(page);
            newPage.itemId = 'item_id_page_' + vm.$makeId(20);
            newPage.itemName = newPage.itemName + ' copy';
            // Process Main Section
            newPage.children = vm.fittingChangeChildrenId(newPage.children, true);
            // Process Inner Sections
            newPage.children = vm.fittingChangeChildrenId(newPage.children, false);
            // Update page  ids
            newPage.children = newPage.children.map(item => {
                return vm.changeChildrenId2(item);
            });
            vm.layers.splice(pageIndex + 1, 0, newPage);
        },
        fittingChangeChildrenId(items, processMainSection = false) {
            let vm = this;
            return items.map(item => {
                vm.inboundItemsToBeRemoved.forEach(inboundItem => {
                    if (item != null) {
                        if (item.itemId == inboundItem.item.itemId) {
                            item = null;
                        }
                    }
                });
                if (item) {
                    let foundItemChildren = vm.outboundedItems.filter(outboundedItem => outboundedItem.parentItemId == item.itemId && !outboundedItem.isMainSestion);
                    let foundItemForMainChildren = vm.outboundedItems.filter(outboundedItem => outboundedItem.parentItemId == item.itemId && outboundedItem.isMainSestion);
                    if (foundItemChildren.length > 0 && !processMainSection) {
                        let processedChildren = foundItemChildren.map(outboundedItem => {
                            return outboundedItem.item;
                        });
                        item.children = processedChildren;

                    } else if (foundItemForMainChildren.length > 0 && processMainSection) {
                        let a = structuredClone(item.children);
                        foundItemForMainChildren.forEach(outboundedItem => {
                            a.push(outboundedItem.item);
                        });
                        let processedChildren = a.map(outboundedItem => {
                            return outboundedItem;
                        });
                        item.children = processedChildren;
                    } else {
                        if (item.children) {
                            item.children = vm.fittingChangeChildrenId(item.children, processMainSection);
                        }
                    }
                    return item;
                }
                return null;
            }).filter(item => item != null);
        },
        changeChildrenId2(child) {
            let vm = this;
            child.itemId = 'item_id_' + vm.$makeId(20);
            if (child.children) {
                child.children = child.children.map(item => {
                    return vm.changeChildrenId2(item);
                });
            }
            return child;
        },
        removeOutboundedItems(children = null) {
            let vm = this;
            let items = children || vm.layers;
            let i = items.length;
            while (i--) {
                let item = items[i];
                vm.outboundedItems.forEach(outboundedItem => {
                    if (item.itemId == outboundedItem.item.itemId) {
                        items.splice(i, 1);
                    }
                });
                if (item.children) {
                    vm.removeOutboundedItems(item.children);
                }
            }
        },
        analizeItemsOutOfViewport(mainParent, parent, children, pageRect) {
            let vm = this;
            children.forEach((item, index) => {
                let child = document.querySelector(`#${item.itemId}`);
                let otherElementRect = child.getBoundingClientRect();
                let isOutOfViewport = pageRect.bottom < otherElementRect.bottom;
                if (isOutOfViewport && item.itemType == 'container_element' && item.dataOrigin != '' && !item.hasProfileContent) {
                    mainParent.foundItemOutbounded = true;
                    let outBoundItem = {
                        parentItemId: parent.itemId,
                        item: item,
                    }
                    vm.outboundedItems.push(outBoundItem);
                }
                if (!isOutOfViewport && item.itemType == 'container_element' && item.dataOrigin != '' && !item.hasProfileContent) {
                    mainParent.foundItemInbounded = true;
                }
                if (item.itemType == 'container_element') {
                    vm.analizeItemsOutOfViewport(mainParent, item, item.children, pageRect);
                }
            });
        },
        getProfileContentSections(children = null, pageIndex = 0) {
            let vm = this;
            let items = children || vm.layers[pageIndex].children;
            let stack = [...items];
            while (stack.length) {
                let item = stack.pop();
                if (item.itemType == 'container_element' && item.isProfileContent) {
                    // eslint-disable-next-line no-undef
                    vm.profileContentSections.push(structuredClone(item));
                }
                if (item.children) {
                    stack.push(...item.children);
                }
            }
        },
        // ============
    }
};
</script>
<style lang="scss">
.cv-template-page {


    .editor-element {
        cursor: pointer;
        // stop user select
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        &.box-element {

            .box-left-edge {
                border-left: 1px dashed transparent;
                position: absolute;
                top: 0px;
                left: -1px;
                bottom: 0px;
            }

            .box-right-edge {
                border-right: 1px dashed transparent;
                position: absolute;
                top: 0px;
                right: -1px;
                bottom: 0px;
            }

            .box-top-edge {
                border-top: 1px dashed transparent;
                position: absolute;
                top: -1px;
                left: 0px;
                right: 0px;
            }

            .box-bottom-edge {
                border-bottom: 1px dashed transparent;
                position: absolute;
                bottom: -1px;
                left: 0px;
                right: 0px;
            }


            &:hover {
                .box-left-edge {
                    &.onMainBox {
                        border-left: 1px dashed #038bc683;
                    }
                }

                .box-right-edge {
                    &.onMainBox {
                        border-right: 1px dashed #038bc683;
                    }
                }

                .box-top-edge {
                    &.onMainBox {
                        border-top: 1px dashed #038bc683;
                    }
                }

                .box-bottom-edge {
                    &.onMainBox {
                        border-bottom: 1px dashed #038bc683;
                    }
                }
            }


            &.activateGuost {
                &:hover {
                    .box-left-edge {
                        border-left: 1px dashed #ccc !important;
                    }

                    .box-right-edge {
                        border-right: 1px dashed #ccc !important;
                    }

                    .box-top-edge {
                        border-top: 1px dashed #ccc !important;
                    }

                    .box-bottom-edge {
                        border-bottom: 1px dashed #ccc !important;
                    }
                }
            }



            .box-left-edge {
                &.active {
                    &.onMainBox {
                        border-left: 1px solid #038bc6;
                        z-index: 999;
                    }
                }
            }

            .box-right-edge {
                &.active {
                    &.onMainBox {
                        border-right: 1px solid #038bc6;
                        z-index: 999;
                    }
                }
            }

            .box-top-edge {
                &.active {
                    &.onMainBox {
                        border-top: 1px solid #038bc6;
                        z-index: 999;
                    }
                }
            }

            .box-bottom-edge {
                &.active {
                    &.onMainBox {
                        border-bottom: 1px solid #038bc6;
                        z-index: 999;
                    }
                }
            }


        }

        &.line-element {
            .box-left-edge {
                border-left: 1px dashed #ccc;
                position: absolute;
                top: 0px;
                left: -1px;
                bottom: 0px;
            }

            .box-right-edge {
                border-right: 1px dashed #ccc;
                position: absolute;
                top: 0px;
                right: -1px;
                bottom: 0px;
            }

            .box-top-edge {
                border-top: 1px dashed #ccc;
                position: absolute;
                top: -1px;
                left: 0px;
                right: 0px;
            }

            .box-bottom-edge {
                border-bottom: 1px dashed #ccc;
                position: absolute;
                bottom: -1px;
                left: 0px;
                right: 0px;
            }


            &:hover {
                .box-left-edge {
                    &.onMainBox {
                        border-left: 1px dashed #038bc683;
                    }
                }

                .box-right-edge {
                    &.onMainBox {
                        border-right: 1px dashed #038bc683;
                    }
                }

                .box-top-edge {
                    &.onMainBox {
                        border-top: 1px dashed #038bc683;
                    }
                }

                .box-bottom-edge {
                    &.onMainBox {
                        border-bottom: 1px dashed #038bc683;
                    }
                }
            }


            &.activateGuost {
                &:hover {
                    .box-left-edge {
                        border-left: 1px dashed #ccc !important;
                    }

                    .box-right-edge {
                        border-right: 1px dashed #ccc !important;
                    }

                    .box-top-edge {
                        border-top: 1px dashed #ccc !important;
                    }

                    .box-bottom-edge {
                        border-bottom: 1px dashed #ccc !important;
                    }
                }
            }



            .box-left-edge {
                &.active {
                    &.onMainBox {
                        border-left: 1px solid #038bc6;
                        z-index: 999;
                    }
                }
            }

            .box-right-edge {
                &.active {
                    &.onMainBox {
                        border-right: 1px solid #038bc6;
                        z-index: 999;
                    }
                }
            }

            .box-top-edge {
                &.active {
                    &.onMainBox {
                        border-top: 1px solid #038bc6;
                        z-index: 999;
                    }
                }
            }

            .box-bottom-edge {
                &.active {
                    &.onMainBox {
                        border-bottom: 1px solid #038bc6;
                        z-index: 999;
                    }
                }
            }
        }

        &.image-element {
            position: relative;
            display: flex;

            .image-left-edge {
                opacity: 0;
                border-left: 1px dashed #038bc6;
                position: absolute;
                top: 0px;
                left: 0px;
                bottom: 0px;
                z-index: 999;
            }

            .image-right-edge {
                opacity: 0;
                border-right: 1px dashed #038bc6;
                position: absolute;
                top: 0px;
                right: 0px;
                bottom: 0px;
                z-index: 999;
            }

            .image-top-edge {
                opacity: 0;
                border-top: 1px dashed #038bc6;
                position: absolute;
                top: 0px;
                left: 0px;
                right: 0px;
                z-index: 999;
            }

            .image-bottom-edge {
                opacity: 0;
                border-bottom: 1px dashed #038bc6;
                position: absolute;
                bottom: 0px;
                left: 0px;
                right: 0px;
                z-index: 999;
            }

            &:hover {
                .image-left-edge {
                    opacity: 1;
                    transition: opacity 0.2s ease-in-out;

                }

                .image-right-edge {
                    opacity: 1;
                    transition: opacity 0.2s ease-in-out;
                }

                .image-top-edge {
                    opacity: 1;
                    transition: opacity 0.2s ease-in-out;
                }

                .image-bottom-edge {
                    opacity: 1;
                    transition: opacity 0.2s ease-in-out;
                }
            }

            &.active {
                .image-left-edge {
                    opacity: 1;
                    border-left: 1px solid #038bc6;
                    z-index: 999;
                }

                .image-right-edge {
                    opacity: 1;
                    border-right: 1px solid #038bc6;
                    z-index: 999;
                }

                .image-top-edge {
                    opacity: 1;
                    border-top: 1px solid #038bc6;
                    z-index: 999;
                }

                .image-bottom-edge {
                    opacity: 1;
                    border-bottom: 1px solid #038bc6;
                    z-index: 999;
                }

            }

            img {
                width: 100%;
                height: 100%;
            }
        }

        &.text-element {


            .text-left-edge {
                opacity: 0;
                border-left: 1px dashed #038bc6;
                position: absolute;
                top: 0px;
                left: 0px;
                bottom: 0px;
                z-index: 999;
            }

            .text-right-edge {
                opacity: 0;
                border-right: 1px dashed #038bc6;
                position: absolute;
                top: 0px;
                right: 0px;
                bottom: 0px;
                z-index: 999;
            }

            .text-top-edge {
                opacity: 0;
                border-top: 1px dashed #038bc6;
                position: absolute;
                top: 0px;
                left: 0px;
                right: 0px;
                z-index: 999;
            }

            .text-bottom-edge {
                opacity: 0;
                border-bottom: 1px dashed #038bc6;
                position: absolute;
                bottom: 0px;
                left: 0px;
                right: 0px;
                z-index: 999;
            }

            &:hover {
                .text-left-edge {
                    opacity: 1;
                    transition: opacity 0.2s ease-in-out;

                }

                .text-right-edge {
                    opacity: 1;
                    transition: opacity 0.2s ease-in-out;
                }

                .text-top-edge {
                    opacity: 1;
                    transition: opacity 0.2s ease-in-out;
                }

                .text-bottom-edge {
                    opacity: 1;
                    transition: opacity 0.2s ease-in-out;
                }
            }

            .text-container {
                display: flex;
                word-break: break-word;

                .text-editable-container {
                    width: 100%;
                    height: 100%;
                    overflow-wrap: break-word !important;
                    -webkit-line-break: after-white-space !important;
                }
            }

            &.active {
                .text-container {
                    .text-editable-container {
                        cursor: text;
                        -webkit-user-modify: read-write !important;

                        &[contenteditable] {
                            outline: 0px solid transparent;
                        }
                    }
                }

                .text-left-edge {
                    opacity: 1;
                    border-left: 1px solid #038bc6;
                    z-index: 999;
                }

                .text-right-edge {
                    opacity: 1;
                    border-right: 1px solid #038bc6;
                    z-index: 999;
                }

                .text-top-edge {
                    opacity: 1;
                    border-top: 1px solid #038bc6;
                    z-index: 999;
                }

                .text-bottom-edge {
                    opacity: 1;
                    border-bottom: 1px solid #038bc6;
                    z-index: 999;
                }

            }
        }

        &.star-element {}

    }
}
</style>
<style lang="scss" scoped>
$assets: "~@/assets/";

.page-wrapper {
    display: flex;
    background: #ebebeb;
    padding: 5px;
    height: 100%;

    .left-panel-section {
        width: 270px;
        height: 100%;
        background: #fff;
        border-radius: 5px;
        border-right: 1px solid #ddd;

        .left-panel-section-header {
            height: 40px;
            padding: 0px 5px;
            display: flex;
            align-items: flex-end;
            border-bottom: 1px solid #ebebeb;

            .btn-back {
                margin-right: 20px;
                display: flex;
                height: 34px;
                align-items: center;
                color: #1ba5a4;
                text-transform: uppercase;


                img {
                    margin-right: 6px;
                    width: 6px;
                }

            }
        }

        .left-panel-section-tabs {
            height: 40px;
            padding: 0px 5px;
            display: flex;
            align-items: flex-end;
            border-bottom: 1px solid #ebebeb;
        }

        .left-panel-section-body {
            height: calc(100% - 40px);
            overflow: auto;

            &.disableScoll {
                overflow: unset !important;
                display: flex;
                flex-direction: column;
            }

            .panel-tab-container {
                display: flex;
                flex-direction: column;
                height: 100%;
            }

            .panel-layer-container {
                display: flex;
                flex-direction: column;
            }
        }
    }

    .middle-panel-section {
        width: calc(100% - 270px);
        height: 100%;
        overflow: hidden;
        border-radius: 5px;


        .middle-panel-section-header {
            height: 40px;
            padding: 0px 5px;
            display: flex;
            align-items: flex-end;
            justify-content: space-between;
            border-bottom: 1px solid #c8c8c8;
            background: #fff;

            .cv-left-options {
                display: flex;
                align-items: center;
                height: 100%;
                padding: 4px 0px;

                .history-navigational-options {
                    display: flex;
                    align-items: center;
                    gap: 5;

                    .btn-backward {

                        display: flex;
                        align-items: center;
                        cursor: pointer;

                        &.inactive {
                            cursor: not-allowed;
                            opacity: 0.5;
                        }

                        img {
                            margin-right: 6px;
                        }
                    }

                    .btn-forward {
                        display: flex;
                        align-items: center;
                        cursor: pointer;

                        &.inactive {
                            cursor: not-allowed;
                            opacity: 0.5;
                        }

                        img {
                            margin-right: 6px;
                        }
                    }
                }

                .option-divider {
                    margin: 0px 20px;
                    height: 70%;
                    border-left: 1px solid #565656;
                }

                .zoom-options {
                    display: flex;
                    align-items: center;
                    gap: 5px;

                    .btn-zoom-in {
                        display: flex;
                        align-items: center;
                        cursor: pointer;

                        img {
                            margin-right: 6px;
                        }
                    }

                    .btn-zoom-out {
                        display: flex;
                        align-items: center;
                        cursor: pointer;

                        img {
                            margin-right: 6px;
                        }
                    }
                }

                .btn-template-versions {
                    border: 1px solid #D0CFCF;
                    height: 28px;
                    padding: 0px 10px;
                    border-radius: 5px;
                }

            }

            .cv-right-options {
                height: 100%;
                display: flex;
            }
        }

        .middle-panel-section-body {
            height: calc(100% - 40px);
            display: flex;

            .middle-panel-section-body-page {
                width: calc(100% - 260px);
                height: 100%;
                overflow: scroll;
                position: relative;
                touch-action: pan-x pan-y;

                .transformation-widget {
                    position: absolute;
                    z-index: 9999;
                    border: 1px solid rgb(7, 220, 227);
                    box-sizing: border-box;
                    width: 200px;
                    height: 100px;
                    top: 40px;
                    cursor: pointer;
                    -webkit-user-select: none;
                    -moz-user-select: none;
                    -ms-user-select: none;
                    user-select: none;
                    display: none;

                    .transformation-center-widget {
                        position: absolute;
                        top: 1px;
                        left: 1px;
                        right: 1px;
                        bottom: 1px;
                        z-index: 1;
                    }

                    .transformation-top-left-corner-widget {
                        position: absolute;
                        top: -5px;
                        left: -5px;
                        width: 10px;
                        height: 10px;
                        border: 1px solid #ddd;
                        background: #fff;
                        z-index: 4;
                        border-radius: 50%;
                        cursor: nwse-resize;
                    }

                    .transformation-top-right-corner-widget {
                        position: absolute;
                        top: -5px;
                        right: -5px;
                        width: 10px;
                        height: 10px;
                        border: 1px solid #ddd;
                        background: #fff;
                        z-index: 4;
                        border-radius: 50%;
                        cursor: nesw-resize;
                    }

                    .transformation-bottom-left-corner-widget {
                        position: absolute;
                        bottom: -5px;
                        left: -5px;
                        width: 10px;
                        height: 10px;
                        border: 1px solid #ddd;
                        background: #fff;
                        z-index: 4;
                        border-radius: 50%;
                        cursor: nesw-resize;
                    }

                    .transformation-bottom-right-corner-widget {
                        position: absolute;
                        bottom: -5px;
                        right: -5px;
                        width: 10px;
                        height: 10px;
                        border: 1px solid #ddd;
                        background: #fff;
                        z-index: 4;
                        border-radius: 50%;
                        cursor: nwse-resize;
                    }

                    .transformation-top-widget {
                        position: absolute;
                        top: -10px;
                        left: 0px;
                        right: 0px;
                        height: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: ns-resize;

                        &::after {
                            content: "";
                            position: relative;
                            top: 4px;
                            width: 17px;
                            height: 3px;
                            background: #fff;
                            border: 1px solid #ddd;
                            border-radius: 8px;
                        }
                    }

                    .transformation-bottom-widget {
                        position: absolute;
                        bottom: -10px;
                        left: 0px;
                        right: 0px;
                        height: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: ns-resize;

                        &::after {
                            content: "";
                            position: relative;
                            bottom: 4px;
                            width: 17px;
                            height: 3px;
                            background: #fff;
                            border: 1px solid #ddd;
                            border-radius: 8px;
                        }
                    }

                    .transformation-rotation-widget {
                        position: absolute;
                        bottom: -8px;
                        left: 0px;
                        right: 0px;
                        height: 0px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .transformation-rotate {
                            position: relative;
                            top: 13px;
                            height: 10px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 10px;
                            background: #fff;
                            box-shadow: 0px 0px 9px #a4a4a4;
                            padding: 8px;
                            border-radius: 50%;
                            cursor: url($assets + "cv-editor-icons/rotate-curso.svg") 12 12,
                                auto !important;

                            img {
                                width: 13px;
                                height: 13px;
                                pointer-events: none;
                            }
                        }
                    }

                    .transformation-left-widget {
                        position: absolute;
                        top: 0;
                        bottom: 0;
                        left: -10px;
                        width: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: ew-resize;

                        &::after {
                            content: "";
                            position: relative;
                            left: 4px;
                            width: 3px;
                            height: 17px;
                            background: #fff;
                            border: 1px solid #ddd;
                            border-radius: 8px;
                        }
                    }

                    .transformation-right-widget {
                        position: absolute;
                        top: 0;
                        bottom: 0;
                        right: -10px;
                        width: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: ew-resize;

                        &::after {
                            content: "";
                            position: relative;
                            right: 4px;
                            width: 3px;
                            height: 17px;
                            background: #fff;
                            border: 1px solid #ddd;
                            border-radius: 8px;
                        }
                    }

                    &.remove-primary-dots {

                        .transformation-top-widget,
                        .transformation-bottom-widget {
                            &::after {
                                display: none;
                            }
                        }
                    }

                    &.remove-secondary-dots {

                        .transformation-left-widget,
                        .transformation-right-widget {
                            &::after {
                                display: none;
                            }
                        }
                    }
                }

                .cv-template-pages-wrapper {
                    position: absolute;
                    height: 100%;
                    margin-top: 30px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: 100%;

                    .cv-template-pages-wrapper-inner {
                        display: flex;
                        margin: auto;
                        flex-shrink: 0;
                        justify-content: center;

                        .cv-template-pages-wrapper-inner-container {
                            margin-left: 56px;
                            margin-right: 56px;
                            width: max-content;

                            .cv-template-page-wrapper {
                                position: relative;
                                display: flex;
                                flex-direction: column;
                                width: var(--page-container-width);

                                .page-options {
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                    width: 100%;
                                    height: 39px;
                                    padding: 0px 5px;
                                    margin-bottom: 1px;
                                    background: #ebebeb;
                                    padding-bottom: 10px;

                                    .page-left-option {
                                        display: flex;
                                    }

                                    .page-right-option {
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;

                                        .page-option {
                                            margin-left: 10px;
                                            padding: 3px;
                                            border-radius: 4px;
                                            height: 21px;
                                            background-color: #f4f4f4;
                                            cursor: pointer;

                                            &:hover {
                                                background-color: #fff;
                                            }

                                            img {
                                                width: 15px;
                                                height: 15px;
                                                pointer-events: none;
                                            }
                                        }
                                    }
                                }

                                .cv-page-container {
                                    width: var(--page-container-width);
                                    height: var(--page-container-height);
                                    margin-bottom: 30px;

                                    .cv-template-page {
                                        position: relative;
                                        background: #fff;
                                        width: 595px;
                                        height: 842px;
                                        transform-origin: 0 0;
                                        transform: var(--normal-zoom);
                                    }
                                }
                            }

                        }
                    }
                }
            }


            .right-panel-section {
                width: 260px;
                background: #fff;
                height: 100%;
                border-left: 1px solid #ddd;

                .right-panel-section-top-header {
                    font-size: 14px;
                    font-weight: 800;
                    height: 30px;
                    padding: 0px 5px;
                    display: flex;
                    align-items: flex-end;

                    span {
                        margin-bottom: -4px;
                    }
                }

                .right-panel-section-header {
                    height: 40px;
                    padding: 0px 5px;
                    display: flex;
                    align-items: flex-end;
                    border-bottom: 1px solid #ebebeb;
                }

                .right-panel-section-body {
                    height: calc(100% - 70px);
                    overflow: auto;
                    padding: 0px 5px;
                }
            }
        }

        .middle-panel-section-footer {
            height: 30px;
            padding: 0px 5px;
            display: none;
            align-items: flex-end;
            border-top: 1px solid #c8c8c8;
            background: #fff;
        }
    }
}
</style>